import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { Description, Close, Attachment, GetApp, Money, LastPage, AllInclusive, Add, MoreVert, Schedule, Block, Subway, Edit, Delete, ErrorOutline, Visibility, Image, Work, BeachAccess, Place, FindReplace, HelpOutline, DepartureBoard, RemoveCircleOutline, PersonAdd, FormatLineSpacing, CheckBoxOutlineBlank, CheckBox, HourglassEmpty, Done } from '@material-ui/icons';


import {
  JsonToCsv,
  useJsonToCsv
} from 'react-json-csv';
import data from "./data";

import {
  CardActionArea,
  TableRow,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  FormHelperText,
  CircularProgress,
  Chip,
  List, ListItem, ListItemText, ListItemAvatar, Avatar, Stepper, Step, StepLabel,
  ListItemSecondaryAction, Popover, Grid
} from "@material-ui/core";

import { withLocalize, Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";

import Dropzone from "react-dropzone";


import API from './api';
import API_ADMIN from './api_admin';
import { useSnackbar } from 'notistack';
// import * as userInfo from "./login_info.js";

import UserInfo from "./login_info";

import Autocomplete from '@material-ui/lab/Autocomplete';

import axios from 'axios';

import imagecaptured from "../../assets/svg/captured.svg";
import imagegenerated from "../../assets/svg/generated.svg";
import imagecompleted from "../../assets/svg/road.svg";

import { TransportService, AdminService, Permissions } from "./../../utils/web_config_2";
import { useAuthUser } from '../../hooks/useUserToken';


const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow: 1,
    [theme.breakpoints.up('sm')]: {
      marginLeft: 250,
    }
  },
  btn: {
    textTransform: "capitalize",

  },
  formTitle: {
    flexGrow: 1,
  }, chip: {
    margin: theme.spacing(0.5),
  }, btn2: {
    textTransform: "capitalize",
    margin: theme.spacing(0.5)
  },
  button: {
    textTransform: "capitalize",
    fontSize: 12
  }
}));




// route steps


function getStepContent(stepIndex) {
  switch (stepIndex) {
    case 0:
      return 'Select campaign settings...';
    case 1:
      return 'What is an ad group anyways?';
    default:
      return 'Unknown stepIndex';
  }
}





function Route() {
  const classes = useStyles1();
  const [operatorData, setOperatorData] = useState({});


  const { saveAsCsv } = useJsonToCsv();

  const filename = "New file",
    fields = {
      "price": "price",
      "route": "route"
    },
    style = {
      padding: "5px"
    },
    text = "Convert Json to Csv";

  const d = [{
    "price": 5000,
    "route": "Kigali-Gicumbi"
  }, {
    "price": 2000,
    "route": "kigali-Rukomo"
  }]

  const saveCsv = () => {
    saveAsCsv({
      d,
      fields,
      filename
    });
  };

  const { token } = useAuthUser();


  useEffect(() => {

    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }
    setOperatorData(data);


    getRoutes(data.token);
    get_stops(data.token);
    get_currencies(data.token);
    get_users(data.token);
    get_branches(data.token);
    get_outletsAssign(data.token);
  }, []);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [dialogMessage, setDialogmessage] = useState(false);
  const [message, setMessage] = useState("");


  const [routeMessage, setRouteMessage] = useState("Loading...");


  // new route dialog 

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  // route table 


  const columns = [
    {
      name: "id",
      label: "id",
      options: {
        display: false,
        filter: true,
        sort: true,
      }
    },
    {
      name: "code",
      label: <Translate id="operator_route.table.code" />,
      options: {
        filter: true,
        sort: true,
      }
    }, {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: false,
      }
    },
    {
      name: "discription",
      label: "Discription",
      options: {
        filter: true,
        sort: false,
      }
    }, {
      name: "interval_time",
      label: <Translate id="operator_route.table.interval_time" />,
      options: {
        filter: true,
        sort: true,
      }
    }, {
      name: "distance",
      label: <Translate id="operator_route.table.distance" />,
      options: {
        filter: true,
        sort: true,
      }
    }, {
      name: "cost",
      label: "Cost",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "currency",
      label: <Translate id="operator_route.table.currency" />,
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "id",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          var obj = routes.find((r) => r.id == value);
          var status = obj.status;
          if (status == "INITIAL" || status == "INTERMIDIATE_ROUTES_GENERATED" || status == "CANCELED") {

            return (
              <Box>
                {status == "INITIAL" &&
                  <Chip
                    color="secondary"
                    variant="outlined"
                    size="small"
                    label={"Captured"}
                    icon={<HourglassEmpty />}

                    onClick={(e) => {
                      setRoutetatus({ value: status, error: "" });
                      setRouteid({ value: value, error: "" });
                      handleEditOpenStatus(e);
                    }
                    }
                  ></Chip>
                }
                {status == "INTERMIDIATE_ROUTES_GENERATED" &&
                  <Chip
                    color="secondary"
                    variant="outlined"
                    size="small"
                    label={"Captured"}
                    icon={<AllInclusive />}

                    onClick={(e) => {
                      setRoutetatus({ value: status, error: "" });
                      setRouteid({ value: value, error: "" });
                      handleEditOpenStatus(e);
                    }
                    }
                  ></Chip>
                }

                {status == "CANCELED" &&
                  <Chip
                    color="secondary"
                    variant="outlined"
                    size="small"
                    label={"Suspend"}
                    icon={<Block />}

                    onClick={(e) => {
                      setRoutetatus({ value: status, error: "" });
                      setRouteid({ value: value, error: "" });
                      handleEditOpenStatus(e);
                    }
                    }
                  ></Chip>
                }

                <Popover
                  id={idStatus}
                  open={openEditStatus}
                  anchorEl={anchorElStatus}
                  onClose={handleEditCloseStatus}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  elevation={1}
                >

                  <Box p={2}>

                    <Typography color="textSecondary">
                      Change Route Status
                    </Typography>

                    <Box mt={2} mb={2}>

                      <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                        <InputLabel htmlFor="status">Choose status</InputLabel>
                        <Select
                          size="small"
                          helperText={"error"}
                          label="Select status"
                          value={routeStatus.value}
                          inputProps={{
                            name: 'status',
                            id: 'status',
                          }}
                          onChange={(e) => {
                            if (e.target.value === "") {
                              setRoutetatus({ value: "", error: "Select status" });
                            } else {

                              setRoutetatus({ value: e.target.value, error: "" });
                            }
                          }}
                          error={routeStatus.error != ""}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value={"INITIAL"}>Captured</MenuItem>
                          <MenuItem value={"PLANED"}>Completed</MenuItem>
                          <MenuItem value={"CANCELED"}>Suspend</MenuItem>
                        </Select>
                        <FormHelperText error={routeStatus.error != ""}>{routeStatus.error}</FormHelperText>
                      </FormControl>

                    </Box>

                    <Button
                      variant="outlined"
                      size="small"
                      color="primary"
                      className={classes.btn2}
                      onClick={handleEditCloseStatus}
                    >
                      Close
                    </Button>

                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      className={classes.btn}
                      disableElevation
                      onClick={() => {
                        change_route_status();
                      }}
                    >
                      {loadStatus ? <CircularProgress color="secondary" size={23} /> : "Save"}
                    </Button>

                  </Box>

                </Popover>

              </Box>

            );
          } else {
            return (
              <Chip
                color="primary"
                label={"Completed"}
                size="small"
                variant="outlined"
                icon={<Done />}

                onClick={(e) => {
                  setRoutetatus({ value: status, error: "" });
                  setRouteid({ value: value, error: "" });
                  handleEditOpenStatus(e);
                }}
              ></Chip>

            );
          }



        }
      }
    }
  ];

  const options = {
    textLabels: {
      body: {
        noMatch: routeMessage
      },
    },
    filterType: 'checkbox',
    download: true,
    responsive: "standard",
    selectableRows: "single",
    rowsPerPage: 10,
    elevation: 0,
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <Box display="flex">
        {/* <Permissions permissions="CAN_EDIT_ROUTE_PRICE"> */}
        <Chip
          color="secondary"
          variant="outlined"
          deleteIcon={<Edit />}
          label={"Modify route"}
          onClick={() => {
            var id = displayData[selectedRows.data[0]['index']]['data'][0];
            var obj = routes.find((item, i) => {
              return item.id == id;
            });

            console.log({
              obj
            })

            setName({ value: obj.name, error: "" });
            setDescription({ value: obj.discription, error: "" });
            setIntervalTime({ value: obj.interval_time, error: "" });
            setDistance({ value: obj.distance, error: "" });
            setCost({ value: obj.cost, error: "" });
            setCode({ value: obj.code });
            setStatus({ value: obj.status, error: "" });
            setRouteid({ value: obj.id, error: "" });

            setCurrencyid({ value: obj.currency_id, error: "" });

            // disable equivalence if is rwandan francs 

            if (obj.currency_id === 1) {
              setIsrwandan(true);
            }

            setDestination({ value: obj.destination, error: "" });
            setOrigin({ value: obj.origin, error: "" });
            setStatus({ value: obj.status });
            setRwequivalence({ value: obj.equivalence, error: "" });
            setRoutetype({ value: obj.routeType, error: "" });

            setRouteDetails(obj);



            console.log(obj);

            setModifydialog(true);
          }}
          onDelete={() => {

          }}
          className={classes.chip}
        />

        {/* </Permissions> */}

        <Permissions permissions="CAN_EDIT_ROUTE">
          <Chip
            color="secondary"
            variant="outlined"
            deleteIcon={<Edit />}
            label={"Change route status"}
            onClick={() => {

              var id = displayData[selectedRows.data[0]['index']]['data'][0];
              var obj = routes.find((item, i) => {
                return item.id == id;
              });


              setRouteid({ value: obj.id });
              setRoutetatus({ value: obj.status, error: "" });
              setChangedialog(true);


            }}
            onDelete={() => {

            }}
            className={classes.chip}
          />

        </Permissions>


        <Chip
          color="secondary"
          variant="outlined"
          deleteIcon={<Visibility />}
          label={"View stops"}
          onClick={() => {
            var id = displayData[selectedRows.data[0]['index']]['data'][0];
            var obj = routes.find((item, i) => {
              return item.id == id;
            });


            console.log("route id" + obj.id);

            if (obj.origin != 0) {
              setRouteid(obj.id);
              get_route_stops(obj.id);
              setStopsdialog(true);
            } else {
              setMessage("Modify route first before you view all stops");
              setDialogmessage(true);

            }

          }}
          onDelete={() => {

          }}
          className={classes.chip}
        />


        <Permissions permissions="CAN_EDIT_ROUTE">
          <Chip
            color="secondary"
            variant="outlined"
            deleteIcon={<Visibility />}
            label={"View Intermediate routes"}
            onClick={() => {

              var id = displayData[selectedRows.data[0]['index']]['data'][0];
              var obj = routes.find((item, i) => {
                return item.id == id;
              });


              setRouteid({ value: id, error: "" })

              if (obj.origin != 0) {
                setIntermediateDialog(true);
                get_intermediates(obj.id);
                get_route_stops(obj.id);
              } else {
                setMessage("Modify route first before you view intermediate routes");
                setDialogmessage(true);

              }



            }}
            onDelete={() => {

            }}
            className={classes.chip}
          />
        </Permissions>

        <Permissions permissions="CAN_EDIT_ROUTE">
          <Chip
            color="secondary"
            variant="outlined"
            deleteIcon={<RemoveCircleOutline />}
            label={"Remove all intermediate routes"}
            onClick={() => {

              var id = displayData[selectedRows.data[0]['index']]['data'][0];
              var obj = routes.find((item, i) => {
                return item.id == id;
              });


              console.log("route id" + obj.id);

              if (obj.origin != 0) {
                setRouteid(obj.id);
                setRemoveDialog(true);
              } else {
                setMessage("Modify route first before you view all stops");
                setDialogmessage(true);

              }



            }}
            onDelete={() => {

            }}
            className={classes.chip}
          />
        </Permissions>

        <Chip
          color="secondary"
          variant="outlined"
          deleteIcon={<PersonAdd />}
          label={"Add User to route outlet"}
          onClick={() => {

            var id = displayData[selectedRows.data[0]['index']]['data'][0];
            var obj = routes.find((item, i) => {
              return item.id == id;
            });
            console.log("route id" + obj.id);

            setAssignDialog(true);
            setRouteid(obj.id);
            get_outlets(obj.id);

          }}
          onDelete={() => {

          }}
          className={classes.chip}
        />
      </Box>
    ),
  };



  // get currency

  const [currencies, setCurrencies] = useState([]);
  const get_currencies = (token) => {
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const currencyInstance = axios.create(new TransportService().setHeaders(token));
    currencyInstance.get("/api/v1/currencies/getCurrencys"
    ).then(res => {
      if (res.status === 200) {
        setCurrencies(res.data);
      }
    })
      .catch(err => {

      });
  }

  // get stops

  const [stops, setStops] = useState([]);
  const get_stops = (token) => {
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const stopsInstance = axios.create(new TransportService().setHeaders(token));
    stopsInstance.get("/api/v1/routePlaning/getStops"
    ).then(res => {
      if (res.status === 200) {
        setStops(res.data);
      }
    })
      .catch(err => {

      });
  }

  const downloadRouteTemplate = async () => {
    console.log({
      token,
      routeId
    })

    let file = await fetch(new TransportService().BASE_URL +"/api/v1/routing/downloadInteroutesByRoute", {
      method: "POST",
      headers: {
        'Authorization': 'Bearer '+token,
        'Content-Type': 'application/json'
      },
      body: routeId.value
    })
    
    const content = new Blob([await file.arrayBuffer()], { type: "application/pdf" });

    const encodedUri = window.URL.createObjectURL(content);
    const link = document.createElement("a");

    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "rura_prices_template_"+Date.now()+".xlsx");

    link.click();
  }

  // route summary


  const [captured, setCaptured] = useState(0);
  const [completed, setCompleted] = useState(0);
  const [generated, setGenerated] = useState(0);


  // get routes

  const [loadRoutes, setLoadRoutes] = useState(false);
  const [routes, setRoutes] = useState([]);
  const getRoutes = (token) => {
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const routesInstance = axios.create(new TransportService().setHeaders(token));
    setLoadRoutes(true);
    routesInstance.get("/api/v1/integrations/getRoutesByOrganization/" + new UserInfo().ORG_ID).then(res => {

      // console.log("routes",res.data);

      setLoadRoutes(false);
      //  console.log(res);
      //  console.log("== routes effect ==",res.data);
      if (res.status == 200) {
        const data = [];
        let d = res.data;
        if (d.length == 0) {
          setRouteMessage("No route available");
        }
        d.sort((a, b) => {
          if (a['name'] > b['name']) {
            return 1;
          } else if (a['name'] < b['name']) {
            return -1;
          }
          return 0;
        });
        if (d.length == 0) {
          setRouteMessage("No routes available");
        }

        count_routes(d);

        d.map((dd) => {
          if (dd.status != "CANCELED") {
            var obj = { id: dd['id'], routeType: dd['route_type'], equivalence: dd['total_route_cost_rw_equivalence'], destination: dd['destination_stop'] !== null ? dd['destination_stop']['id'] : 0, origin: dd['origin_stop'] != null ? dd['origin_stop']['id'] : 0, currency_id: dd['currency'] != null ? dd['currency']['id'] : 0, id: dd['id'], code: dd['code'], name: dd['name'], discription: dd['description'], interval_time: dd['time_interval_minute'], distance: dd['total_route_distance_km'], cost: dd['total_route_cost'], currency: dd['currency'] != null ? dd['currency']['code'] : "No currency", status: dd['status'] };
            data.push(obj);
          }
        });
        setRoutes(data);
      }
    }).catch(err => {
      setLoadRoutes(false);
    });
  }


  // add new route 


  const [addStatus, setAddstatus] = useState({ load: false, status: false });
  const [cost, setCost] = useState({ value: "", error: "" });
  const [costCurrency, setCostcurrency] = useState({ value: "", error: "" });
  const [description, setDescription] = useState({ value: "", error: "" });
  const [name, setName] = useState({ value: "", error: "" });



  const addRoute = () => {
    if (name.value === "") {
      setName({ value: "", error: "Enter route name" });
    } else if (cost.value === "") {
      setCost({ value: "", error: "Enter cost" });
    } else if (origin.value === 0) {
      setOrigin({ value: 0, error: "Select origin stop" });
      console.log("orign");
    } else if (destination.value === 0) {
      setDestination({ value: 0, error: "Select destination stop" });
      console.log("destination");
    } else if (costCurrency.value === "") {
      setCostcurrency({ value: "", error: "Select currency" });
    } else if (description.value === "") {
      setDescription({ value: "", error: "Enter description" });
    } else if (name.value === "") {
      setName({ value: "", error: "Enter route name" })
    } else {

      axios.defaults.baseURL = new AdminService().BASE_URL;
      const routesInstance = axios.create(new AdminService().setHeaders(operatorData.token));
      setAddstatus({ load: true, status: false });
      routesInstance.post("/api/v1/operator-route",
        {
          "cost": cost.value,
          "cost_currency": costCurrency.value,
          "description": description.value,
          "name": name.value,
          "organization_id": new UserInfo().ORG_ID
        }).then(res => {

          if (res.status === 200) {
            var id = res.data.data.operator_route_id;
            get_route_details(id);

            //   setAddstatus({load:false,status:true});
            //   setOpen(false);
            //   enqueueSnackbar('Route added successful!', { 
            //     variant: 'success',
            //     anchorOrigin: {
            //       vertical: 'bottom',
            //       horizontal: 'right',
            //   },
            // });

            // getRoutes();

            let cap = 0;
            var com = 0;
            var gen = 0;
            routes.map((dd) => {
              if (dd['status'] == "INITIAL") {
                cap = cap + 1;
              }
              if (dd['status'] == "PLANED") {
                com = com + 1;
              }
              if (dd['status'] == "INTERMIDIATE_ROUTES_GENERATED") {
                gen++;
              }
            });

          }
        }).catch(err => {
          setAddstatus({ load: false, status: false });
          enqueueSnackbar(err.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        });
    }
  }


  //get route details from transport micro service


  const [routeDetails, setRouteDetails] = useState({});
  const get_route_details = (id) => {
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const detailsInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    detailsInstance.get('/api/v1/integrations/getRouteByAdminId/' + id)
      .then(res => {
        var obj = res.data;
        console.log("==============route details=============");
        console.log(obj);
        setRouteid({ value: obj.id, error: "" });
        setRouteDetails(obj);
        setAddstatus({ load: false, status: false });
        handleNext();
      }).catch(err => {
        enqueueSnackbar(err.message, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      });
  }



  // modify route dialog
  const [modifyDialog, setModifydialog] = useState(false);

  // modify route
  const [modifyStatus, setModifystatus] = useState({ load: false, status: false });
  const [routeId, setRouteid] = useState({ value: 0, error: "" });
  const [intervalTime, setIntervalTime] = useState({ value: 0, error: "" });
  const [distance, setDistance] = useState({ value: 0, error: "" });
  const [origin, setOrigin] = useState({ value: 0, error: "" });
  const [destination, setDestination] = useState({ value: 0, error: "" });
  const [code, setCode] = useState({ value: "", error: "" });
  const [status, setStatus] = useState({ value: "", error: "" });
  const [rwEquivalence, setRwequivalence] = useState({ value: 0, error: "" });
  const [routeType, setRoutetype] = useState({ value: "", error: "" });
  const [currencyId, setCurrencyid] = useState({ value: 0, error: "" });
  const [isRwandan, setIsrwandan] = useState(false);



  const [phone, setPhone] = useState({ value: "", error: "" });


  const modify_route = () => {

    if (currencyId.value === "") {
      setCostcurrency({ value: "", error: "Select currency" });
      console.log("currency id");
    } else if (intervalTime.value === 0) {
      setIntervalTime({ value: 0, error: "Enter interval time" });
      console.log("interval time");
    } else if (distance.value === 0) {
      setDistance({ value: 0, error: "Enter distance" });
      console.log("distance");
    } else if (origin.value === 0) {
      setOrigin({ value: 0, error: "Select origin stop" });
      console.log("orign");
    } else if (destination.value === 0) {
      setDestination({ value: 0, error: "Select destination stop" });
      console.log("destination");
    } else if (phone.value === "") {
      setPhone({ value: "", error: "Enter phone number" });
      console.log("phone number");
    } else if (currencyId.value === "") {
      setCurrencyid({ value: "", error: "Select currency" });
      console.log("idcurrency ");
    }
    else {
      // console.log(
      //   "code"+code.value,
      //   "currency_id"+ currencyId.value,
      //   "default_arrival_time"+ "2020-07-21 10:03:53",
      //   "default_departure_time"+ "2020-07-21 10:03:53",
      //   "description"+description.value,
      //   "destination_stop_id"+ destination.value,
      //   "id"+ routeId.value,
      //   "name"+ name.value,
      //   "organization_id"+ new UserInfo().ID,
      //   "origin_stop_id"+ origin.value,
      //   "phone_number"+ phone.value,
      //   "route_type"+ routeType.value,
      //   "status"+ status.value,
      //   "time_interval_minute"+intervalTime.value,
      //   "total_route_cost"+ cost.value,
      //   "total_route_cost_rw_equivalence"+rwEquivalence.value,
      //   "total_route_distance_km"+ distance.value
      // );

      axios.defaults.baseURL = new TransportService().BASE_URL;

      setModifystatus({ load: true, status: false });
      const modifyInstance = axios.create(new TransportService().setHeaders(operatorData.token));

      modifyInstance.put("/api/v1/routePlaning/modifyRoute",
        {
          "code": routeDetails.code,
          "currency_id": currencyId.value,
          "default_arrival_time": "2020-07-21 10:03:53",
          "default_departure_time": "2020-07-21 10:03:53",
          "description": routeDetails.description,
          "destination_stop_id": destination.value,
          "id": routeId.value,
          "name": routeDetails.name,
          "organization_id": new UserInfo().ID,
          "origin_stop_id": origin.value,
          "phone_number": phone.value,
          "route_type": routeDetails.route_type,
          "status": routeDetails.status,
          "time_interval_minute": intervalTime.value,
          "total_route_cost": routeDetails.total_route_cost,
          "total_route_cost_rw_equivalence": rwEquivalence.value,
          "total_route_distance_km": distance.value
        }
      ).then(res => {
        setModifystatus({ load: false, status: false });
        if (res.status === 201) {

          var objs = routes;
          var n_obj = res.data;
          var obj = { id: n_obj['id'], routeType: n_obj['route_type'], equivalence: n_obj['total_route_cost_rw_equivalence'], destination: n_obj['destination_stop'] !== null ? n_obj['destination_stop']['id'] : 0, origin: n_obj['origin_stop'] != null ? n_obj['origin_stop']['id'] : 0, currency_id: n_obj['currency'] != null ? n_obj['currency']['id'] : 0, id: n_obj['id'], code: n_obj['code'], name: n_obj['name'], discription: n_obj['description'], interval_time: n_obj['time_interval_minute'], distance: n_obj['total_route_distance_km'], cost: n_obj['total_route_cost'], currency: n_obj['currency'] != null ? n_obj['currency']['code'] : "No currency", status: n_obj['status'] };
          objs.unshift(obj);

          setRoutes(objs);



          setModifystatus({ load: false, status: true });
          setModifydialog(false);
          enqueueSnackbar('Route modified successful!', {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });

          handleNext();
          // getRoutes();
        }
      }).catch(err => {
        setModifystatus({ load: false, status: false });

        if (err.message) {
          enqueueSnackbar(err.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }


        if (err.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }

      })
    }
  }



  // modify existing route


  const modify_existing_route = () => {

    if (currencyId.value === "") {
      setCostcurrency({ value: "", error: "Select currency" });
      console.log("currency id");
    } else if (intervalTime.value === 0) {
      setIntervalTime({ value: 0, error: "Enter interval time" });
      console.log("interval time");
    } else if (distance.value === 0) {
      setDistance({ value: 0, error: "Enter distance" });
      console.log("distance");
    } else if (origin.value === 0) {
      setOrigin({ value: 0, error: "Select origin stop" });
      console.log("orign");
    } else if (destination.value === 0) {
      setDestination({ value: 0, error: "Select destination stop" });
      console.log("destination");
    } else if (phone.value === "") {
      setPhone({ value: "", error: "Enter phone number" });
      console.log("phone number");
    } else if (currencyId.value === "") {
      setCurrencyid({ value: "", error: "Select currency" });
      console.log("idcurrency ");
    }
    else {
      // console.log(
      //   "code"+code.value,
      //   "currency_id"+ currencyId.value,
      //   "default_arrival_time"+ "2020-07-21 10:03:53",
      //   "default_departure_time"+ "2020-07-21 10:03:53",
      //   "description"+description.value,
      //   "destination_stop_id"+ destination.value,
      //   "id"+ routeId.value,
      //   "name"+ name.value,
      //   "organization_id"+ new UserInfo().ID,
      //   "origin_stop_id"+ origin.value,
      //   "phone_number"+ phone.value,
      //   "route_type"+ routeType.value,
      //   "status"+ status.value,
      //   "time_interval_minute"+intervalTime.value,
      //   "total_route_cost"+ cost.value,
      //   "total_route_cost_rw_equivalence"+rwEquivalence.value,
      //   "total_route_distance_km"+ distance.value
      // );

      // console.log({
      //   "code": code.value,
      //   "currency_id": currencyId.value,
      //   "default_arrival_time": "2020-07-21 10:03:53",
      //   "default_departure_time": "2020-07-21 10:03:53",
      //   "description": description.value,
      //   "destination_stop_id": destination.value,
      //   "id": routeId.value,
      //   "name": name.value,
      //   "organization_id": new UserInfo().ID,
      //   "origin_stop_id": origin.value,
      //   "phone_number": phone.value,
      //   "route_type": routeType.value,
      //   "status": status.value,
      //   "time_interval_minute": intervalTime.value,
      //   "total_route_cost":cost.value,
      //   "total_route_cost_rw_equivalence": rwEquivalence.value,
      //   "total_route_distance_km": distance.value
      // });

      axios.defaults.baseURL = new TransportService().BASE_URL;
      const modifyInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      setModifystatus({ load: true, status: false });
      modifyInstance.put("/api/v1/routePlaning/modifyRoute",
        {
          "code": code.value,
          "currency_id": currencyId.value,
          "default_arrival_time": "2020-07-21 10:03:53",
          "default_departure_time": "2020-07-21 10:03:53",
          "description": description.value,
          "destination_stop_id": destination.value,
          "id": routeId.value,
          "name": name.value,
          "organization_id": new UserInfo().ID,
          "origin_stop_id": origin.value,
          "phone_number": phone.value,
          "route_type": routeType.value,
          "status": status.value,
          "time_interval_minute": intervalTime.value,
          "total_route_cost": cost.value,
          "total_route_cost_rw_equivalence": rwEquivalence.value,
          "total_route_distance_km": distance.value
        }
      ).then(res => {
        // console.log("====== response =====",res.data);
        setModifystatus({ load: false, status: false });
        if (res.status === 201) {

          setModifystatus({ load: false, status: true });
          setModifydialog(false);
          enqueueSnackbar('Route modified successful!', {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });

          var index = routes.findIndex((r) => r.id == routeId.value);

          var objs = routes;
          var n_obj = res.data;
          var obj = { id: n_obj['id'], routeType: n_obj['route_type'], equivalence: n_obj['total_route_cost_rw_equivalence'], destination: n_obj['destination_stop'] !== null ? n_obj['destination_stop']['id'] : 0, origin: n_obj['origin_stop'] != null ? n_obj['origin_stop']['id'] : 0, currency_id: n_obj['currency'] != null ? n_obj['currency']['id'] : 0, id: n_obj['id'], code: n_obj['code'], name: n_obj['name'], discription: n_obj['description'], interval_time: n_obj['time_interval_minute'], distance: n_obj['total_route_distance_km'], cost: n_obj['total_route_cost'], currency: n_obj['currency'] != null ? n_obj['currency']['code'] : "No currency", status: n_obj['status'] };
          objs[index] = obj;
          setRoutes(objs);

          handleNext();
          // getRoutes();
        }
      }).catch(err => {
        setModifystatus({ load: false, status: false });
        enqueueSnackbar(err.response.data.message, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      })
    }
  }




  // head dialog

  const [dialogHead, setDialogHead] = useState(false);

  // add new stop to head
  const [headStatus, setHeadstatus] = useState({ load: false, status: false });
  const [prevHead, setPrevHead] = useState({ value: 0, error: "" });
  const [newHead, setNewHead] = useState({ value: 0, error: "" });
  const add_stop_head = () => {
    if (newHead.value === 0) {
      setNewHead({ value: 0, error: "Select stop head" });
    } else {
      setHeadstatus({ load: true, status: false });
      console.log(newHead.value);
      console.log(prevHead.value);
      axios.defaults.baseURL = new TransportService().BASE_URL;
      const headInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      headInstance.post("/api/v1/routePlaning/addStopToRouteHead",
        {
          "new_head_stop_id": newHead.value,
          "old_head_rooute_stop_id": prevHead.value
        }
      ).then(res => {
        console.log("stop head");

        setHeadstatus({ load: false, status: false });
        if (res.status === 201) {
          setHeadstatus({ load: false, status: true });
          setDialogHead(false);
          enqueueSnackbar('Head stop changed successful!', {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
          get_route_stops(Id);
        } else {
          console.log("error");
        }
        console.log(res);
        console.log(res.data);
      }).catch(err => {
        setHeadstatus({ load: false, status: false });
        enqueueSnackbar(err.message, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      });
    }
  }



  // change route status popover

  // edit intermediate route 


  const [anchorElStatus, setAnchorElStatus] = useState(null);

  const handleEditOpenStatus = (event) => {
    setAnchorElStatus(event.currentTarget);
  };

  const handleEditCloseStatus = () => {
    setAnchorElStatus(null);
  };

  const openEditStatus = Boolean(anchorElStatus);
  const idStatus = openEditStatus ? 'simple-popover' : undefined;


  // change status route
  const [changeDialog, setChangedialog] = useState(false);

  // change route status 
  const [loadStatus, setLoadstatus] = useState(false);
  const [routeStatus, setRoutetatus] = useState({ value: "", error: "" });
  const [comment, setComment] = useState({ value: "", error: "" });
  const change_route_status = () => {

    if (routeStatus.value === "") {
      setRoutetatus({ value: "", error: "Select status" });
    }

    // else if(comment.value===""){
    //   setComment({value:"",error:"Enter comment"});
    // }

    else {
      axios.defaults.baseURL = new TransportService().BASE_URL;
      const routeInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      setLoadstatus(true);
      routeInstance.put("/api/v1/routing/changeRouteStatus",
        {
          "comment": "string",
          "route_id": routeId.value,
          "status": routeStatus.value
        }
      ).then(res => {

        if (routeStatus.value == "CANCELED") {
          var objs = routes.filter((r) => r.id != routeId.value);

          setLoadstatus(false);
          count_routes(objs);

          setChangedialog(false);
          enqueueSnackbar('Route removed successful!', {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
          handleEditCloseStatus();
          setRoutes(objs);

        } else {
          var objs = routes;
          var index = routes.findIndex((r) => r.id == routeId.value);
          var dd = res.data;
          console.log("== obj ==", obj);
          var obj = { id: dd['id'], routeType: dd['route_type'], equivalence: dd['total_route_cost_rw_equivalence'], destination: dd['destination_stop'] !== null ? dd['destination_stop']['id'] : 0, origin: dd['origin_stop'] != null ? dd['origin_stop']['id'] : 0, currency_id: dd['currency'] != null ? dd['currency']['id'] : 0, id: dd['id'], code: dd['code'], name: dd['name'], discription: dd['description'], interval_time: dd['time_interval_minute'], distance: dd['total_route_distance_km'], cost: dd['total_route_cost'], currency: dd['currency'] != null ? dd['currency']['code'] : "No currency", status: dd['status'] };
          objs[index] = obj;
          setLoadstatus(false);
          count_routes(objs);


          setChangedialog(false);
          enqueueSnackbar('Route status modified successful!', {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
          handleEditCloseStatus();
          setRoutes(objs);

        }


      }).catch(err => {
        setLoadstatus(false);
        enqueueSnackbar(err.message, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });

        if (err.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }

      });
    }

  }



  // view stops dialog 

  const [stopsDialog, setStopsdialog] = useState(false);

  // view stops
  const [Id, setId] = useState(0);
  const [routeStopLoad, setRouteStopLoad] = useState(false);
  const [routeStops, setRoutestops] = useState([]);
  const get_route_stops = (id) => {
    setId(id);
    setRouteStopLoad(true);
    setRoutestops([]);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const stopsInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    stopsInstance.get("/api/v1/routePlaning/getStopsByRoute/" + id)
      .then(res => {
        setRouteStopLoad(false);
        if (res.data.length == 0) {
          enqueueSnackbar('No Stops available', {
            variant: 'info',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
          setRoutestops(res.data);
        } else {
          console.log("====  list of stops  ======", res.data);
          setRoutestops(res.data);
          setPrevHead({ value: res.data[0]['id'], error: "" });
        }
        if (res.status == 200) {

        } else {
          /// error message
        }
      }).catch(err => {
        enqueueSnackbar(err.message, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      });
  }



  /// add tail stop dialog

  const [tailDialog, setTailDialog] = useState(false);

  /// add tail stop 
  const [tailId, setTailId] = useState({ value: 0, error: "" });
  const [tailStopLoad, setTailStopLoad] = useState(false);
  const add_tail_stop = () => {
    if (tailId.value == 0) {
      setTailId({ value: 0, error: "Select stop" });
    } else {
      // console.log("===================")
      // console.log("id"+Id)
      // console.log("tail value"+tailId.value);
      setTailStopLoad(true);
      axios.defaults.baseURL = new TransportService().BASE_URL;
      const tailInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      tailInstance.post("/api/v1/routePlaning/addStopToRouteTail",
        {
          "node_type": "HEAD",
          "route_id": Id,
          "status": "ACTIVE",
          "stop_id": tailId.value,
          "stop_order": 0
        }).then(res => {
          console.log("server", res);
          setTailStopLoad(false);
          if (res.status == 201) {
            setTailDialog(false);
            enqueueSnackbar('Tail stop added successful!', {
              variant: 'success',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
            get_route_stops(Id);
          } else {
            // error message 
          }
        }).catch(err => {
          setTailStopLoad(false);
          enqueueSnackbar(err.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        })
    }

  }

  //========================================================================================================

  //  addd stop between dialog

  const [betweenDialog, setBetweendialog] = useState(false);

  // add stop between stops 
  const [newStop, setNewStop] = useState({ value: 0, error: "" });
  const [firstStop, setFirstStop] = useState({ value: 0, error: "" });
  const [secondStop, setSecondStop] = useState({ value: 0, eeror: "" });

  const [betweenLoad, setBetweenLoad] = useState(false);

  const insert_stop_between = () => {

    if (firstStop.value === 0) {
      setFirstStop({ value: 0, error: "Select first stop" });
    } else if (secondStop.value === 0) {
      setSecondStop({ value: 0, error: "" });
    } else if (firstStop.value == secondStop.value) {
      setSecondStop({ value: 0, error: "Select diferent stop" });
      setFirstStop({ value: 0, error: "Select diferent stop " });
    } else {
      setBetweenLoad(true);
      axios.defaults.baseURL = new TransportService().BASE_URL;
      const betweenInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      betweenInstance.put("/api/v1/routePlaning/insertAStopBetweenTwoStopsOfARoute",
        {
          "created_at": "2020-07-30 09:17:44",
          "created_by": "string",
          "first_route_stop_id": firstStop.value,
          "new_stop_id": newStop.value,
          "second_route_stop_id": secondStop.value,
          "updated_at": "2020-07-30 09:17:44",
          "updated_by": "string"
        })
        .then(res => {
          setBetweenLoad(false);
          if (res.status === 201) {
            setBetweendialog(false);
            enqueueSnackbar('Stop added successful!', {
              variant: 'success',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
            get_route_stops(Id);
          } else {
            // error message 
          }
        }).catch(err => {
          setBetweenLoad(false);
          if (err.message) {
            enqueueSnackbar(err.message, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
          }

          if (err.response) {
            enqueueSnackbar(err.response.data.message, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
          }

        })
    }

  }


  // remove stop in route set 


  const remove_stop = (id) => {
    setRouteStopLoad(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const removeInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    removeInstance.post('/api/v1/routePlaning/deleteStopFromRpoute', {
      "route_id": routeId,
      "route_stop_id": id
    })
      .then(res => {
        var objs = routeStops.filter((r) => r.id != id);
        setRoutestops(objs);
        setRouteStopLoad(false);
        enqueueSnackbar("Stop removed successfuly!", {
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      })
      .catch(err => {
        setRouteStopLoad(false);
        if (err.message) {
          enqueueSnackbar(err.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }

        if (err.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }

      })
  }




  //========================================================================================================

  // intermediate rooutes dialog


  // get intermediates



  const [intermediateDialog, setIntermediateDialog] = useState(false);
  const [intermediates, setIntermediates] = useState([]);
  const [intermediateLoad, setIntermediateLoad] = useState(false);
  const [intermediateMessage, setIntermediateMessage] = useState("");
  const get_intermediates = (id) => {
    setId(id);
    setIntermediateLoad(true);
    setIntermediateMessage("");
    setIntermediates([]);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const intermediateInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    intermediateInstance.get("/api/v1/routing/findIntermidiateRoutesByMainRoute/" + id)
      .then(res => {
        console.log("intermediates route", res)
        setIntermediateLoad(false);
        if (res.data.length == 0) {
          setIntermediateMessage("No intermediate routes available!");
        }
        var objs = res.data;
        objs.map((o) => {
          if (o['stops_combination'].indexOf("#") >= 0) {
            var stop_combinations = o['stops_combination'].split("#");
            o['stops_combination'] = stop_combinations[1];
          } else {
            o['stops_combination'] = o['stops_combination'];
          }


        });
        setIntermediates(objs);
        setTemp(objs);
        setIntermediateLoad(false);

      }).catch(err => {
        setIntermediateLoad(false);
        enqueueSnackbar(err.message, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      })
  }


  // filter intermediate route 

  const [temp, setTemp] = useState([]);

  const [filterIntermediate, setFilterIntermediate] = useState({ value: "", error: "" });

  const filter_intermediate = (v) => {
    if (v == "") {
      setIntermediates(temp);
    } else {
      var f = temp.filter((o) => o.stops_combination.toLowerCase().includes(v.toLowerCase()));
      console.log("f", f);
      setIntermediates(f);
    }
  }



  // generate intermediate routes dialog

  const [generateDialog, setGenerateDialog] = useState(false);

  // generate intermediate routes

  const [generateLoad, setGenerateLoad] = useState(false);
  const generate_intermediate_routes = () => {
    setGenerateLoad(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const generateInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    generateInstance.post("/api/v1/routing/generateIntermidiateRoutes", Id
    ).then(res => {
      // console.log("generate");
      // console.log(res);
      setGenerateLoad(false);
      if (res.status == 201) {
        setGenerateDialog(false);
        enqueueSnackbar('Intermedia route generated successful!', {
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
        get_intermediates(Id);
      } else {

      }
    }).catch(err => {
      setGenerateLoad(false);
      enqueueSnackbar(err.message, {
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
      });


      if (err.response) {
        enqueueSnackbar(err.response.data.message, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      }

    });

  }


  //// remove all intermediates routes  dialog

  const [removeDialog, setRemoveDialog] = useState(false);


  /// remove intermediates route 
  const [removeLoad, setRemoveLoad] = useState(false);
  const remove_intermediate = () => {
    setRemoveLoad(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const removeInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    removeInstance.put("/api/v1/routePlaning/freeRouteNodes", routeId
    ).then(res => {
      console.log("remove intermediate route ");
      console.log(res);
      setRemoveLoad(false);
      setRemoveDialog(false);
      enqueueSnackbar('Intermediate route removed successful!', {
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
      });

    }).catch(error => {

      enqueueSnackbar("You can not remove intermediate routes that are being used or scheduled!", {
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
      });
      setRemoveLoad(false);
      console.log("error");
      console.log(error);
    })

  }

  /// get routeoutlet of a specific route 

  const [loadOutlet, setLoadOutlet] = useState(false);
  const [outlets, setOutelets] = useState([]);
  const get_outlets = (id) => {
    setLoadOutlet(true);
    setOutelets([]);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const outletInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    outletInstance.get('/api/v1/branching/findRouteOutletsByRoute/' + id
    ).then(res => {
      setOutelets(res.data);
      console.log(res.data);
      setLoadOutlet(false);
    }).catch(err => {
      console.log(err);
    })

  }


  /// get user by organization 

  const [users, setUsers] = useState([]);
  const get_users = (token) => {
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const userInstance = axios.create(new TransportService().setHeaders(token));
    userInstance.get('/api/v1/integrations/getUsersByOrganization/' + new UserInfo().ORG_ID
    ).then(res => {
      var d = res.data;
      var dd = d.filter((x) => x.user_type == "POS_USER");
      if (dd.length == 0) {
        //no pos users availeble
      } else {
        setUsers(dd);
      }
    }).catch(err => {
      console.log("failed to get users" + err);
    })
  }



  /// assign user to route aoutlet
  const [assignLoad, setAssignLoad] = useState(false);
  const [assignDialog, setAssignDialog] = useState(false);
  const [userId, setUserId] = useState({ value: 0, error: "" });
  const [routeOutletId, setRouteOutletId] = useState({ value: 0, error: "" });
  const assign_user_to_routeoutlet = () => {
    if (userId.value == 0) {
      setUserId({ value: 0, error: "Select user" });
    } else if (routeOutletId.value === 0) {
      setRouteOutletId({ value: 0, error: "Select outlet" });
    } else {
      setAssignLoad(true);
      axios.defaults.baseURL = new TransportService().BASE_URL;
      const assignInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      assignInstance.put('/api/v1/branching/associateUserToRouteAndOutlet',
        {
          "comment": "string",
          "route_outlet_id": routeOutletId.value,
          "user_id": userId.value
        }
      ).then(res => {
        setAssignLoad(false);
        setAssignDialog(false);
        enqueueSnackbar("User assigned successful!", {
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      }).catch(err => {
        setAssignLoad(false);
        console.log(err);
      })

    }

  }


  // create route in steps


  const [activeStep, setActiveStep] = useState(0);
  const steps = ['Create route', 'Modify Route', 'Assign Outlet'];

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };


  // edit intermediate route 


  const [anchorEl, setAnchorEl] = useState(null);

  const handleEditOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleEditClose = () => {
    setAnchorEl(null);
  };

  const openEdit = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;


  // edit intermediate 

  const [intermediateDetails, setIntermediateDetails] = useState({});

  const [intermediateStatus, setIntermediateStatus] = useState({ value: "", error: "" });

  const [editIntermediateLoad, setEditIntermediateLoad] = useState(false);
  const [intermediateTimeInterval, setIntermediateTimeInterval] = useState({ value: 0, error: "" });
  const [intermediateDistanceKm, setIntermediateDistanceKm] = useState({ value: 0, error: "" });

  const edit_intermediate = () => {
    if (cost.value <= 0) {
      setCost({ value: 0, error: "Enter cost" });
    } else if (intermediateTimeInterval.value <= 0) {
      setIntermediateTimeInterval({ value: 0, error: "Enter valid interval" });
    } else if (intermediateDistanceKm.value <=0){
      setIntermediateDistanceKm({ value: 0, error: "Enter valid KM" });
    }
    else if (intermediateStatus.value == "") {
      setIntermediateStatus({ value: "", error: "Select status" });
    }
    else {
      setEditIntermediateLoad(true);
      axios.defaults.baseURL = new TransportService().BASE_URL;
      const intermediateInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      intermediateInstance.put('/api/v1/routing/modifyIntermidiateRoute', {
        "default_arrival_time": intermediateDetails['default_arrival_time'],
        "default_departure_time": intermediateDetails['default_departure_time'],
        "default_price_to_destination_stop": intermediateDetails['price_to_destination_stop'],
        "destination_route_stop_id": intermediateDetails['destination_route_stop']['id'],
        "id": intermediateDetails.id,
        "main_route_id": Id,
        "origin_route_stop_id": intermediateDetails['originRouteStop']['id'],
        "route_order": intermediateDetails['route_order'],
        "route_type": intermediateDetails['route_type'],
        "status": intermediateStatus.value,
        "time_interval_minute": intermediateTimeInterval.value,
        "total_route_cost": cost.value,
        "total_route_cost_rw_equivalence": intermediateDetails['total_route_cost_rw_equivalence'],
        "total_route_distance_km": intermediateDistanceKm.value
      })
        .then(res => {
          // console.log("iiiiiiinnnnnnttttt",res.data);
          // setEditIntermediateLoad(false);

          var index = temp.findIndex((i) => i.id == intermediateDetails['id']);
          var objs = temp;
          objs[index]['total_route_cost'] = cost.value;
          objs[index]['time_interval_minute'] = intermediateTimeInterval.value;

          // to be changed late after meditation 

          // setTemp(objs);
          // setIntermediates(objs);


          /////////////////

          change_intermediate_status(intermediateDetails.id);

          //   enqueueSnackbar("Intermediate updated successful!", { 
          //     variant: 'success',
          //     anchorOrigin: {
          //       vertical: 'bottom',
          //       horizontal: 'right',
          //   },
          // });

        })
        .catch(err => {
          setEditIntermediateLoad(false);
          enqueueSnackbar(err.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });

          if (err.response) {
            enqueueSnackbar(err.response.data.message, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
          }


        });


    }

  }


  const change_intermediate_status = (id) => {
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const intermediateInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    intermediateInstance.put('/api/v1/routing/changeIntermidieteRouteStatus', {
      "route_id": id,
      "comment": "string",
      "status": intermediateStatus.value,
    })
      .then(res => {

        // console.log("iiiiiiinnnnnnttttt",res.data);

        setEditIntermediateLoad(false);

        var index = temp.findIndex((i) => i.id == intermediateDetails['id']);
        var objs = temp;
        objs[index]['total_route_cost'] = cost.value;
        objs[index]['time_interval_minute'] = intermediateTimeInterval.value;
        objs[index]['total_route_distance_km'] = intermediateDistanceKm.value;
        objs[index]['status'] = intermediateStatus.value;

        setTemp(objs);
        // setIntermediates(objs);
        setAnchorEl(null);

        enqueueSnackbar("Intermediate updated successful!", {
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      })
      .catch(err => {
        setEditIntermediateLoad(false);
        enqueueSnackbar(err.message, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });

        if (err.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }

      });
  }


  // move stop in route set (change stop order)


  // const [anchorEls, setAnchorEls] = useState(null);

  // const handleEditOpens = (event) => {
  //   setAnchorEls(event.currentTarget);
  // };

  // const handleEditCloses = () => {
  //   setAnchorEls(null);
  // };

  // const [opens,setOpens]=useState(false);

  // const openEdits = Boolean(anchorEls);
  // const ids = opens ? 'simple-popover' : undefined;

  // const [routeStopId,setRouteStopId]=useState(0);
  // const [stopOrder,setStopOrder]=useState(0);
  // const [stopId,setStopId]=useState(0);
  // const [moveLoad,setMoveLoad]=useState(false);
  // const [nodeType,setNodeType]=useState("");
  // const move_stop=()=>{
  //   setMoveLoad(true);
  //   const moveInstance = axios.create(new TransportService().setHeaders(token));
  //   moveInstance.put('',{
  //     "id": routeStopId,
  //     "node_type": nodeType,
  //     "route_id": routeId.value,
  //     "status": "ACTIVE",
  //     "stop_id": stopId,
  //     "stop_order": stopOrder
  //   })
  //   .then(res=>{
  //     console.log("===== move stop response ==== ",res.data);
  //     enqueueSnackbar("Stop moved successfuly!", { 
  //       variant: 'success',
  //       anchorOrigin: {
  //         vertical: 'bottom',
  //         horizontal: 'right',
  //     },
  //   });
  //   setMoveLoad(false);

  //   })
  //   .catch(err=>{
  //     setMoveLoad(false);
  //     if(err.message){
  //       enqueueSnackbar(err.message, { 
  //         variant: 'error',
  //         anchorOrigin: {
  //           vertical: 'bottom',
  //           horizontal: 'right',
  //       },
  //     });
  //     }

  //     if(err.response){
  //       enqueueSnackbar(err.response.data.message, { 
  //         variant: 'error',
  //         anchorOrigin: {
  //           vertical: 'bottom',
  //           horizontal: 'right',
  //       },
  //     });
  //     }

  //   });
  // }




  // get branches

  const [branches, setBranches] = useState([]);
  const get_branches = (token) => {
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const branchesInstance = axios.create(new TransportService().setHeaders(token));
    branchesInstance.get('/api/v1/branching/getBranchs')
      .then(res => {
        var id = new UserInfo().ID;
        var objs_ = res.data;
        var objs = objs_.filter((b) => b.organization.id == id);
        setBranches(objs);
      })
      .catch(err => {

        if (err.message) {
          enqueueSnackbar(err.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }

        if (err.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }

      });
  }


  // get outlets 

  const [outletFilter, setOutletFilter] = useState([]);
  const [outletsAssign, setOutletsAssign] = useState([]);
  const get_outletsAssign = (token) => {
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const outletInstance = axios.create(new TransportService().setHeaders(token));
    outletInstance.get('/api/v1/branching/getOutlets')
      .then(res => {
        setOutletsAssign(res.data);
      })
      .catch(err => {

        if (err.message) {
          enqueueSnackbar(err.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }

        if (err.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }

      });

  }



  /// assign route to outlet 


  const [outletId, setOUtletId] = useState({ value: [], error: "" });
  const assign_route_outlet = () => {
    if (outletId.value.length == 0) {
      setOUtletId({ value: [], error: "Choose outlet" });
    } else {

      setAddstatus({ load: true, status: false });

      var r = [];
      r.push(routeId.value);
      axios.defaults.baseURL = new TransportService().BASE_URL;
      const assignnstance = axios.create(new TransportService().setHeaders(operatorData.token));
      assignnstance.put('/api/v1/branching/addOutletsToRoute',
        {
          "outlet_ids": outletId.value + "",
          "route_id": routeId.value
        }

        // {
        //   "outlet_id": outletId.value,
        //   "route_ids":r+""
        // }

      )
        .then(res => {
          enqueueSnackbar("Route added in outlet successfuly!", {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
          setAddstatus({ load: false, status: false });
          // handleNext();
          setOpen(false);
        })
        .catch(err => {
          setAddstatus({ load: false, status: false });
          if (err.message) {
            enqueueSnackbar(err.message, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
          }

          if (err.response) {
            enqueueSnackbar(err.response.data.message, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
          }

        });
    }

  }



  const count_routes = (r) => {
    let cap = 0;
    var com = 0;
    var gen = 0;
    r.map((dd) => {
      if (dd['status'] == "INITIAL") {
        cap = cap + 1;
      }
      if (dd['status'] == "PLANED") {
        com = com + 1;
      }
      if (dd['status'] == "INTERMIDIATE_ROUTES_GENERATED") {
        gen++;
      }
    });

    setGenerated(gen);
    setCaptured(cap);
    setCompleted(com);
  }



  /// add new intermediate route 

  const [addIntermediateDialog, setAddIntermediateDialog] = useState(false);

  const [addIntermediateLoad, setAddIntermediateLoad] = useState(false);

  const [originRouteStopId, setOriginRouteStopId] = useState({ value: 0, error: "" });
  const [destinationRouteStopId, setDestinationRouteStopId] = useState({ value: 0, error: "" });
  const [totalRouteCost, setTotalRouteCost] = useState({ value: 0, error: "" });
  const [iDistance, setIdistance] = useState({ value: 0, error: "" });
  const [iInterval, setIinterval] = useState({ value: 0, error: "" });
  const [iEquivalence, setIequivalence] = useState({ value: 0, error: "" });


  const add_intermediate = () => {


    if (originRouteStopId.value == 0) {
      setOriginRouteStopId({ value: 0, error: "Select origin stop" });
    } else if (destinationRouteStopId.value == 0) {
      setDestinationRouteStopId({ value: 0, error: "Select detsination stop" })
    } else if (totalRouteCost.value == 0) {
      setTotalRouteCost({ value: 0, error: "Enter total route cost" });
    } else if (iDistance.value == 0) {
      setIdistance({ value: 0, error: "Enter Distance" });
    } else if (iInterval.value == 0) {
      setIinterval({ value: 0, error: "Enter distance" });
    } else {
      console.log("destinationRouteStopId.value", destinationRouteStopId.value)
      console.log("Id", Id)
      console.log("originRouteStopId.value", originRouteStopId.value)
      console.log("iInterval.value", iInterval.value)
      console.log("totalRouteCost.value", totalRouteCost.value)
      console.log("iEquivalence.value", iEquivalence.value)
      console.log("iEquivalence.value", iDistance.value)
      setAddIntermediateLoad(true);
      const intermediateInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      intermediateInstance.post('/api/v1/routing/addIntermidiateRoute', {
        "default_arrival_time": "2020-10-05 08:53:54",
        "default_departure_time": "2020-10-05 08:53:54",
        "default_price_to_destination_stop": 0,
        "destination_route_stop_id": destinationRouteStopId.value,
        "main_route_id": Id,
        "origin_route_stop_id": originRouteStopId.value,
        "route_order": "o",
        "route_type": "PARENT",
        "status": "INITIAL",
        "time_interval_minute": iInterval.value,
        "total_route_cost": totalRouteCost.value,
        "total_route_cost_rw_equivalence": iEquivalence.value,
        "total_route_distance_km": iDistance.value
      })
        .then(res => {
          var obj = res.data;
          console.log("intermediate object", obj);
          var objs = intermediates;
          objs.unshift(obj);
          setIntermediates(objs);

          var objs2 = temp;
          objs2.unshift(obj);
          setTemp(obj);

          enqueueSnackbar("Intermediate route added successful!", {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
          setAddIntermediateDialog(false);
          setAddIntermediateLoad(false);
        })
        .catch(err => {
          if (err.message) {
            enqueueSnackbar(err.message, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
          }

          console.log(err.response.data);

          if (err.response) {
            enqueueSnackbar(err.response.data.message, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
          }
          setAddIntermediateLoad(false);
        });


    }

  }




  // upload price 

  const [choosenFile, setChoosenFile] = useState([]);

  const [uploadDialog, setUploadDialog] = useState(false);

  const [priceFile, setPriceFile] = useState(undefined);

  const [uploadPriceLoad, setUploadPriceLoad] = useState(false);


  const uploadPrice = () => {
    if (choosenFile.length != 0) {
      setUploadPriceLoad(true);
      const data = new FormData()
      data.append('pricesFile', priceFile[0])

      const priceInstance = axios.create(new TransportService().setHeadersFile(operatorData.token));
      priceInstance.put("/api/v1/routing/uploadRoutePrices/" + Id, data)
        .then(res => {
          setUploadDialog(false);
          setUploadPriceLoad(false);
          get_intermediates(Id);
          enqueueSnackbar("Price uploaded successful!", {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });

          setChoosenFile([]);
          // console.log("response after price upload",res.data);



        })
        .catch(err => {

          setChoosenFile([]);

          setUploadPriceLoad(false);
          enqueueSnackbar(err.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });

          if (err.response) {
            enqueueSnackbar(err.response.data.message, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
          }
        });


    } else {
      // error message 
      enqueueSnackbar("File not found", {
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
      });
    }
  }

  return (
    <Box className={classes.root}>
      <Box display="flex">

        <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>

          <Box mr={1}><Subway fontSize="large" color="primary" /></Box> <Typography variant="h5" color="default"><b><Translate id="operator_route.route" /></b></Typography>

        </Box>


        <Button
          className={classes.btn}
          size="small"
          startIcon={<Add />}
          onClick={() => { handleClickOpen() }}
          variant="contained"
          color="primary"
          disableElevation={true}>

          <Typography noWrap><Translate id="operator_route.new_route" /></Typography>
        </Button>

      </Box>

      {/* route table  */}

      <Box mt={1}>
        <Grid container spacing={1}>

          {/* route captured  */}

          <Grid item xs={12} md={4} >
            <Paper className={classes.paper} elevation={0}>
              <Grid container>
                <Grid item xs={8} md={8}>
                  <Box display="flex" justifyContent="center"><Typography variant="h8">Captured</Typography></Box>
                  <Box mt={2} display="flex" justifyContent="center"><Typography variant="h5">{captured}</Typography></Box>

                </Grid>

                <Grid item xs={4} md={4}>
                  <Box p={1}>
                    <img src={imagecaptured} width="80px" height="80px" />
                  </Box>
                </Grid>

              </Grid>
            </Paper>
          </Grid>



          {/* route generated  */}


          <Grid item xs={12} md={4} >
            <Paper className={classes.paper} elevation={0}>
              <Grid container>
                <Grid item xs={8} md={8}>
                  <Box display="flex" justifyContent="center"><Typography variant="h8" >Generated</Typography></Box>
                  <Box mt={2} display="flex" justifyContent="center"><Typography variant="h5">{generated}</Typography></Box>

                </Grid>
                <Grid item xs={4} md={4}>
                  <Box p={1}>
                    <img src={imagegenerated} width="80px" height="80px" />
                  </Box>
                </Grid>

              </Grid>
            </Paper>
          </Grid>

          {/* route completed  */}

          <Grid item xs={12} md={4} >
            <Paper className={classes.paper} elevation={0}>
              <Grid container>
                <Grid item xs={8} md={8}>
                  <Box display="flex" justifyContent="center"><Typography variant="h8" >Completed</Typography></Box>
                  <Box mt={2} display="flex" justifyContent="center"><Typography variant="h5">{completed}</Typography></Box>
                </Grid>
                <Grid item xs={4} md={4}>
                  <Box p={1}>
                    <img src={imagecompleted} width="80px" height="80px" />
                  </Box>
                </Grid>

              </Grid>
            </Paper>
          </Grid>
        </Grid>

      </Box>





      <Box mt={2}>

        {loadRoutes && <LinearProgress />}
        <MUIDataTable
          title={"Route list"}
          data={routes}
          columns={columns}
          options={options}
        />
      </Box>

      {/* dialog new route  */}

      <Dialog
        maxWidth="sm"
        fullWidth
        open={false}
        aria-labelledby="new route"
        aria-describedby="new route"
      >
        <DialogTitle id="new route"> <Translate id="operator_route.new_route" /> </DialogTitle>
        <DialogContent>
          <DialogContentText >

            <Box>

              <Box display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
                onChange={(e) => {
                  if (e.target.value === "") {
                    setName({ value: "", error: "Enter route name" });
                  } else {
                    setName({ value: e.target.value, error: "" });
                  }
                }}
                error={name.error != ""}
                helperText={name.error}
                label={<Translate id="operator_route.from_new_route.name" />} color='primary' fullWidth /></Box>



              <Box display='flex' mt={1} alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
                type="number"
                onChange={(e) => {
                  if (e.target.value === "") {
                    setCost({ value: "", error: "Enter route cost" });
                  } else {
                    setCost({ value: e.target.value, error: "" });
                  }
                }}
                error={cost.error != ""}
                helperText={cost.error}
                label={<Translate id="operator_route.from_new_route.cost" />} color='primary' fullWidth /></Box>
              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                  <InputLabel htmlFor="currency"><Translate id="operator_route.from_new_route.choose_currency" /></InputLabel>
                  <Select
                    size="small"
                    helperText={"error"}
                    label="Select currency"
                    inputProps={{
                      name: 'currency',
                      id: 'currency',
                    }}
                    onChange={(e) => {
                      if (e.target.value === "") {
                        setCostcurrency({ value: "", error: "Select currency" });
                      } else {
                        setCostcurrency({ value: e.target.value, error: "" });
                      }
                    }}
                    error={costCurrency.error != ""}

                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={"RWF"}>RWF</MenuItem>
                    <MenuItem value={"USD"}>USD</MenuItem>
                  </Select>
                  <FormHelperText error={costCurrency.error != ""}>{costCurrency.error}</FormHelperText>
                </FormControl>
              </Box>




              <Box mt={1}>
                <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>

                  <TextField size="small" rowsMax={5} rows={10} variant='outlined' label={<Translate id="operator_route.from_new_route.description" />}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setDescription({ value: "", error: "Enter description" });
                      } else {
                        setDescription({ value: e.target.value, error: "" });
                      }
                    }}
                    error={description.error !== ""}
                    helperText={description.error}
                    color='primary' fullWidth multiline />
                </FormControl>
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button className={classes.btn} onClick={handleClose} color="secondary" autoFocus>
            <Translate id="operator_route.from_new_route.cancel" />
          </Button>

          <Permissions permissions="CAN_CREATE_ROUTE"><Button className={classes.btn} disableElevation onClick={() => { addRoute() }} variant="contained" color="primary">
            {addStatus.load ? <CircularProgress size={25} color="secondary" /> : <Translate id="operator_route.from_new_route.save" />}
          </Button>
          </Permissions>

        </DialogActions>
      </Dialog>


      {/* modify route dialog */}


      <Dialog
        maxWidth="sm"
        fullWidth
        open={modifyDialog}
        aria-labelledby="modify route"
        aria-describedby="modify route"
      >
        <DialogTitle id="modify_route"> <Translate id="operator_route.form_modify_route.title" /> </DialogTitle>
        <DialogContent>
          <DialogContentText >

            <Box>

              <Box display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
                onChange={(e) => {
                  if (e.target.value === "") {
                    setName({ value: "", error: "Enter route name" });
                  } else {
                    setName({ value: e.target.value, error: "" });
                  }
                }}
                value={name.value}
                error={name.error != ""}
                helperText={name.error}
                label={<Translate id="operator_route.form_modify_route.name" />} color='primary' fullWidth /></Box>

              <Box display='flex' mt={1} alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
                onChange={(e) => {
                  if (e.target.value === "") {
                    setPhone({ value: "", error: "Enter phone number" });
                  } else {
                    setPhone({ value: e.target.value, error: "" });
                  }
                }}
                value={phone.value}
                error={phone.error != ""}
                helperText={phone.error}
                label={<Translate id="operator_route.form_modify_route.phone" />} color='primary' fullWidth /></Box>



              <Box display='flex' mt={1} alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
                type="number"
                onChange={(e) => {
                  if (e.target.value === "") {
                    setCost({ value: "", error: "Enter route cost" });
                  } else {
                    setCost({ value: e.target.value, error: "" });
                  }
                }}
                value={cost.value}
                error={cost.error != ""}
                helperText={cost.error}
                label={<Translate id="operator_route.form_modify_route.cost" />} color='primary' fullWidth /></Box>


              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                <TextField size='small' variant='outlined' type="number" label={<Translate id="operator_route.form_modify_route.interval_minute" />}
                  value={intervalTime.value}
                  error={intervalTime.error !== ""}
                  helperText={intervalTime.error}
                  onChange={(e) => {
                    if (e.target.value === 0) {
                      console.log(e.target.value);
                      setIntervalTime({ value: 0, error: "Enter interval time" });
                    } else {
                      setIntervalTime({ value: e.target.value, error: "" })
                    }
                  }}
                  color='primary' fullWidth />
              </Box>
              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                <TextField size='small' variant='outlined' type="number" label={<Translate id="operator_route.form_modify_route.distance" />}
                  value={distance.value}
                  onChange={(e) => {
                    if (e.target.value === 0) {
                      setDistance({ value: 0, error: "Enter distance" });
                    } else {
                      setDistance({ value: e.target.value, error: "" });
                    }
                  }}
                  color='primary' fullWidth />
              </Box>

              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>

                <Autocomplete
                  size="small"
                  options={stops}
                  getOptionLabel={(option) => option.name}

                  value={stops.find((s) => s.id == origin.value)}
                  fullWidth
                  onChange={(event, newValue) => {

                    if (newValue == null) {
                      setOrigin({ value: 0, error: "Select origin" });
                    } else {
                      setOrigin({ value: newValue.id, error: "" });
                    }
                  }}
                  renderInput={(params) => <TextField {...params} label="Select origin" variant="outlined" />}
                />


              </Box>

              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                <Autocomplete
                  size="small"
                  options={stops}
                  getOptionLabel={(option) => option.name}
                  value={stops.find((s) => s.id == destination.value)}
                  fullWidth
                  onChange={(event, newValue) => {

                    if (newValue == null) {
                      setDestination({ value: 0, error: "" });
                    } else {
                      setDestination({ value: newValue.id, error: "" });
                    }
                  }}
                  renderInput={(params) => <TextField {...params} label="Select destination" variant="outlined" />}

                />
              </Box>


              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                  <InputLabel htmlFor="currency"><Translate id="operator_route.form_modify_route.choose_currency" /></InputLabel>
                  <Select
                    size="small"
                    helperText={"error"}
                    label="Select currency"
                    inputProps={{
                      name: 'currency',
                      id: 'currency',
                    }}
                    defaultValue={currencyId.value}
                    onChange={(e) => {
                      if (e.target.value === 0) {
                        setCurrencyid({ value: 0, error: "Select currency" });
                      } else {
                        if (e.target.value === 1) {
                          setIsrwandan(true);
                        } else {
                          setIsrwandan(false);
                        }
                        setCurrencyid({ value: e.target.value, error: "" });
                      }
                    }}
                    error={costCurrency.error != ""}
                  >
                    <MenuItem value={0}>
                      <em>None</em>
                    </MenuItem>
                    {currencies.map((c) => {
                      return <MenuItem value={c['id']}>{c['code']}</MenuItem>;
                    })}
                  </Select>
                  <FormHelperText error={costCurrency.error != ""}>{costCurrency.error}</FormHelperText>
                </FormControl>
              </Box>
              {isRwandan == false && <Box display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
                onChange={(e) => {
                  if (e.target.value === "") {
                    setRwequivalence({ value: "", error: "Enter equivalent" });
                  } else {
                    setRwequivalence({ value: e.target.value, error: "" });
                  }
                }}
                error={rwEquivalence.error != ""}
                helperText={rwEquivalence.error}
                label={<Translate id="operator_route.form_modify_route.equivalence" />} color='primary' fullWidth />
              </Box>}


              <Box mt={1}>
                <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>

                  <TextField size="small" rowsMax={5} rows={10} variant='outlined' label={<Translate id="operator_route.form_modify_route.description" />}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setDescription({ value: "", error: "Enter description" });
                      } else {
                        setDescription({ value: e.target.value, error: "" });
                      }
                    }}
                    value={description.value}
                    error={description.error !== ""}
                    helperText={description.error}
                    color='primary' fullWidth multiline />
                </FormControl>
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button className={classes.btn} onClick={() => {
            setModifydialog(false);
          }} color="secondary" autoFocus>
            <Translate id="operator_route.form_modify_route.cancel" />
          </Button>


          <Button className={classes.btn} disableElevation onClick={() => {
            modify_existing_route();
          }} variant="contained" color="primary">
            {modifyStatus.load ? <CircularProgress size={25} color="secondary" /> : <Translate id="operator_route.form_modify_route.save" />}

          </Button>

        </DialogActions>
      </Dialog>



      {/* dialog add head stop  */}



      <Dialog
        maxWidth="sm"
        fullWidth
        open={dialogHead}
        aria-labelledby="addroutestop"
        aria-describedby="addroutestop"
      >
        <DialogTitle id="addroutestop"> <Translate id="operator_route.form_add_stop_head.title" /> </DialogTitle>
        <DialogContent>
          <DialogContentText >

            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>


              <Autocomplete
                size="small"
                options={stops}
                getOptionLabel={(option) => option.name}
                fullWidth

                onChange={(event, newValue) => {
                  if (newValue == null) {
                    setNewHead({ value: 0, error: "Select stop" });
                  } else {
                    console.log("stop head" + newValue.id);
                    setNewHead({ value: newValue.id, error: "" });
                  }
                }}



                renderInput={(params) => <TextField {...params} label="Select origin" variant="outlined" />}


              />


              {/* <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                 <InputLabel htmlFor="location"><Translate id="operator_route.form_add_stop_head.choose_stop" /></InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select stop"
        inputProps={{
          name: 'stop',
          id: 'stop',
        }}
        error={newHead.error!=0}
        helperText={newHead.error}
        onChange={(e)=>{
          if(e.target.value==0){
            setNewHead({value:0,error:""});
          }else{
            setNewHead({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value={0}>
            <em>None</em>
          </MenuItem>
          {stops.map((s)=>{
            return <MenuItem value={s['id']}>{s['name']}</MenuItem>;
          })}
        </Select>
        <FormHelperText error={newHead.error!=0}>{newHead.error}</FormHelperText>
      </FormControl> */}
            </Box>

          </DialogContentText>

        </DialogContent>

        <DialogActions>

          <Button className={classes.btn} onClick={() => {
            setDialogHead(false);
          }} color="secondary" autoFocus>
            <Translate id="operator_route.form_modify_route.cancel" />
          </Button>


          <Button className={classes.btn} disableElevation onClick={() => { add_stop_head(); }} variant="contained" color="primary">
            {headStatus.load ? <CircularProgress size={25} color="secondary" /> : <Translate id="operator_route.form_modify_route.save" />}

          </Button>

        </DialogActions>
      </Dialog>



      {/* change status route */}


      <Dialog
        maxWidth="sm"
        fullWidth
        open={changeDialog}
        aria-labelledby="change_route_status"
        aria-describedby="change_route_status"
      >
        <DialogTitle id="change_route_status"> Change route status </DialogTitle>
        <DialogContent>
          <DialogContentText >

            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
              <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                <InputLabel htmlFor="status">Status</InputLabel>
                <Select
                  size="small"
                  helperText={"error"}
                  label="Select Status"
                  inputProps={{
                    name: 'status',
                    id: 'status',
                  }}
                  error={routeStatus.error != 0}
                  helperText={routeStatus.error}
                  onChange={(e) => {
                    if (e.target.value == 0) {
                      setRoutetatus({ value: "", error: "Select route status" });
                    } else {
                      setRoutetatus({ value: e.target.value, error: "" });
                    }
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={"INITIAL"}>{"Initial"}</MenuItem>
                  <MenuItem value={"PLANED"}>{"Planed"}</MenuItem>
                  <MenuItem value={"CANCELED"}>{"Canceled"}</MenuItem>

                </Select>
                <FormHelperText error={routeStatus.error != 0}>{routeStatus.error}</FormHelperText>
              </FormControl>
            </Box>

            <Box mt={1}>
              <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>

                <TextField size="small" rowsMax={5} rows={10} variant='outlined' label={"Description"}
                  error={comment.error != ""}
                  helperText={comment.error}
                  onChange={(e) => {
                    if (e.target.value == "") {
                      setComment({ value: "", error: "Enter comment" });
                    } else {
                      setComment({ value: e.target.value, error: "" })
                    }
                  }}
                  color='primary' fullWidth multiline />
              </FormControl>
            </Box>

          </DialogContentText>

        </DialogContent>

        <DialogActions>

          <Button className={classes.btn} onClick={() => {
            setChangedialog(false);
          }} color="secondary" >
            Cancel
          </Button>


          <Button className={classes.btn} disableElevation onClick={() => { change_route_status(); }} variant="contained" color="primary" autoFocus>
            {loadStatus ? <CircularProgress size={25} color="secondary" /> : "Save"}

          </Button>

        </DialogActions>
      </Dialog>



      {/* dialog message  */}



      <Dialog
        maxWidth="sm"
        fullWidth
        open={dialogMessage}
        aria-labelledby="message"
        aria-describedby="message"
      >
        <DialogTitle id="message">Message </DialogTitle>
        <DialogContent>
          <DialogContentText >

            <Box mt={1} display='flex' alignItems='center' >
              <ErrorOutline fontSize="large" /><Typography>{message}</Typography>
            </Box>
          </DialogContentText>

        </DialogContent>

        <DialogActions>

          <Button className={classes.btn} onClick={() => {
            setDialogmessage(false);
          }} color="secondary" >
            Close
          </Button>




        </DialogActions>
      </Dialog>




      {/* dialog view stops  */}



      <Dialog
        maxWidth="sm"
        minHeight={200}
        fullWidth
        open={stopsDialog}
        aria-labelledby="stop_list"
        aria-describedby="stop_list"
      >
        <DialogTitle id="stop_list">Stops list</DialogTitle>
        <DialogContent>
          <DialogContentText >
            {routeStopLoad && <LinearProgress />}

            {routeStopLoad == false &&
              <Box mt={1} display="flex">
                <Chip
                  color="secondary"
                  variant="outlined"
                  deleteIcon={<Add />}
                  label={"Add Head Stop"}
                  onClick={() => {
                    setDialogHead(true);
                    // if(obj.origin!=0){
                    //   setPrevHead({value:obj.origin,error:""});
                    //   setDialogHead(true);
                    // }else{
                    //   setMessage("Modify route first before you add head stop");
                    //   setDialogmessage(true);

                    // }

                  }}
                  onDelete={() => {

                  }}
                  className={classes.chip}
                />



                <Chip
                  color="secondary"
                  variant="outlined"
                  deleteIcon={<Add />}
                  label={"Add Stop Between"}
                  onClick={() => {
                    setBetweendialog(true);
                  }}
                  onDelete={() => {

                  }}
                  className={classes.chip}
                />

                <Chip
                  color="secondary"
                  variant="outlined"
                  deleteIcon={<Add />}
                  label={"Add Tail Stop"}
                  onClick={() => {
                    console.log("selected route " + Id);
                    setTailDialog(true);
                  }}
                  onDelete={() => {

                  }}
                  className={classes.chip}
                />
              </Box>
            }

            <Box mt={1} display='flex'>


              <List style={{ width: "100%" }}>
                {routeStops.map((r) => {
                  return <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <Place />
                      </Avatar>
                    </ListItemAvatar>

                    <ListItemText primary={r['stop']['name']} secondary={r['node_type']} />

                    <ListItemSecondaryAction>

                      {/* <IconButton edge="end" aria-label="delete" onClick={
                      ()=>{
                        setStopOrder();
                        handleEditOpens();
                      }
                      }>
                    <Typography>{r['stop_order']}</Typography>
                      <FormatLineSpacing />
                    </IconButton> */}

                      <IconButton edge="end" aria-label="delete" onClick={() => {
                        console.log("remove stop");
                        remove_stop(r['id']);
                      }}>
                        <RemoveCircleOutline fontSize="medium" />
                      </IconButton>


                      {/* <Popover
        id={ids}
        open={openEdits}
        anchorEl={anchorEls}
        onClose={handleEditCloses}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        elevation={1}
      >

<Box p={2}>
          <Typography color="textSecondary">
           Move stop
          </Typography>
          <Box mt={2} mb={2}>
           
          </Box>
        
          <Button
            variant="outlined"
            size="small"
            color="primary"
            className={classes.btn2}
            onClick={handleEditCloses}
          >
            Close
          </Button>
          <Button
            variant="contained"
            size="small"
            color="primary"
            className={classes.btn}
            disableElevation
            onClick={()=>{

            }}
          >
            Move
          </Button>
        </Box>
    
      </Popover> */}
                    </ListItemSecondaryAction>
                  </ListItem>;
                })}

              </List>

            </Box>
          </DialogContentText>

        </DialogContent>

        <DialogActions>

          <Button className={classes.btn} onClick={() => {
            setStopsdialog(false);
          }} color="secondary" >
            Close
          </Button>




        </DialogActions>
      </Dialog>




      {/* dialog add tail stop */}

      <Dialog
        maxWidth="sm"
        minHeight={200}
        fullWidth
        open={tailDialog}
        aria-labelledby="add_tail_stop"
        aria-describedby="add_tail_stop"
      >
        <DialogTitle id="stop_list">Add Tail Stop</DialogTitle>
        <DialogContent>
          <DialogContentText >
            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>

              <Autocomplete
                size="small"
                options={stops}
                getOptionLabel={(option) => option.name}
                fullWidth
                onChange={(event, newValue) => {

                  if (newValue == null) {
                    setTailId({ value: 0, error: "Select tail stop" });
                  } else {
                    setTailId({ value: newValue.id, error: "" });
                  }
                }}
                renderInput={(params) => <TextField {...params} label="Select tail stop" variant="outlined" />}


              />
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button className={classes.btn} onClick={() => {
            setTailDialog(false);
          }} color="secondary" >
            Close
          </Button>


          <Button className={classes.btn} onClick={() => {
            add_tail_stop();
          }} color="primary" variant="contained" disabled={tailStopLoad}>

            {tailStopLoad ? <CircularProgress color="secondary" size={25} /> : "Add stop"}

          </Button>



        </DialogActions>
      </Dialog>




      {/* view intermediate routes  */}




      <Dialog
        maxWidth="sm"
        minHeight={200}
        fullWidth
        open={intermediateDialog}
        aria-labelledby="stop_list"
        aria-describedby="stop_list"
      >
        <DialogTitle id="stop_list">List of intermediate routes</DialogTitle>
        <DialogContent>




          <DialogContentText >
            {intermediateLoad && <LinearProgress />}

            {intermediateLoad == false &&


              <Box>

                <Box mb={1} mt={1} display="flex">

                  <Grid container display="flex" justifyContent="center">
                    <Grid md={4}>
                      <Box display="flex" justifyContent="center" >
                        <Button
                          variant="outlined"
                          color="secondary"
                          className={classes.button}
                          startIcon={<DepartureBoard />}
                          onClick={() => {
                            setGenerateDialog(true);
                          }}
                        >
                          Generate intermediates
                        </Button>
                      </Box>



                    </Grid>
                    <Grid md={4} display="flex" justifyContent="center">
                      <Box display="flex" justifyContent="center" >
                        {/* <JsonToCsv
        data={data}
        filename={filename}
        fields={fields}
        style={style}
        text={text}
      /> */}
                        {/* <button onClick={saveCsv}>
        useJsonToCsv
      </button> */}
                        <Button
                          variant="outlined"
                          color="secondary"
                          className={classes.button}
                          startIcon={<Money />}
                          onClick={() => {
                            setUploadDialog(true);

                          }}
                        >
                          Upload Prices
                        </Button>

                      </Box>



                    </Grid>
                    <Grid display="flex" justifyContent="center" md={4}>
                      <Box display="flex" justifyContent="center" >
                        <Button
                          variant="outlined"
                          color="secondary"
                          className={classes.button}
                          startIcon={<Add />}
                          onClick={() => {
                            setAddIntermediateDialog(true);
                          }}
                        >
                          Add intermediate
                        </Button>
                      </Box>

                      {/* <Chip
color="secondary"
variant="outlined"
icon={<Add/>}
label={"Add intermediate"}
onClick={()=>{
  setAddIntermediateDialog(true);
}}
/> */}
                    </Grid>

                  </Grid>


                  <Box lg={4} md={4} display="flex" alignItems='center' justifyContent='center' >




                  </Box>

                  <Box lg={4} md={4} display="flex" alignItems='center' justifyContent='center'>



                  </Box>


                  <Box lg={4} md={4} display="flex" alignItems='center' justifyContent='center'>


                  </Box>

                </Box>


                <TextField size="small" label={"Search Intermediate"} variant="outlined" type="text" fullWidth onChange={(e) => {
                  filter_intermediate(e.target.value);
                }} />

              </Box>
            }

            <Box mt={1} display='flex'>

              <Typography>{intermediateMessage}</Typography>
              <List style={{ width: '100%' }}>
                {intermediates.map((i, index) => {
                  return <ListItem >
                    <ListItemAvatar>
                      <Avatar>
                        <Place />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={i["stops_combination"]} secondary={"Status: " + i['status'] + " | Price:" + i['total_route_cost'] + " " + i['currency'] + " | Interval:" + i['time_interval_minute'] + " Mins"} />
                    <ListItemSecondaryAction>
                      <IconButton edge="end" aria-label="delete" onClick={(e) => {
                        setIntermediateDetails(intermediates[index]);
                        setCost({ value: intermediates[index]['total_route_cost'], error: "" });
                        setIntermediateTimeInterval({ value: intermediates[index]['time_interval_minute'], error: "" });
                        setIntermediateStatus({ value: intermediates[index]['status'], error: "" });
                        handleEditOpen(e);
                      }}>
                        <Edit />
                      </IconButton>
                      <Popover
                        id={id}
                        open={openEdit}
                        anchorEl={anchorEl}
                        onClose={handleEditClose}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'center',
                        }}
                        elevation={1}
                      >

                        <Box p={2}>
                          <Typography color="textSecondary">
                            Edit Intermediate route
                          </Typography>
                          <Box mt={2} mb={2}>
                            <TextField
                              size="small"
                              label="Price"
                              placeholder="Price"
                              fullWidth
                              variant="outlined"
                              defaultValue={intermediateDetails['total_route_cost']}
                              onChange={(e) => {

                                if (e.target.value <= 0) {
                                  setCost({ value: 0, error: "Enter valid cost" });
                                } else {
                                  setCost({ value: e.target.value, error: "" });
                                }

                              }}
                              type="number"
                              error={cost.error != ""}
                              helperText={cost.error}
                            />
                          </Box>


                          <Box mt={2} mb={2}>
                            <TextField
                              size="small"
                              label="Distance(KM)"
                              placeholder="Distance(KM)"
                              fullWidth
                              variant="outlined"
                              defaultValue={intermediateDetails['total_route_distance_km']}
                              onChange={(e) => {
                                if (e.target.value <= 0) {
                                  setIntermediateDistanceKm({ value: 0, error: "Enter valid KM" });
                                } else {
                                  setIntermediateDistanceKm({ value: e.target.value, error: "" });
                                }
                              }}
                              type="number"
                              error={intermediateDistanceKm.error != ""}
                              helperText={intermediateDistanceKm.error}
                            />
                          </Box>


                          <Box mt={2} mb={2}>
                            <TextField
                              size="small"
                              label="Interval"
                              placeholder="Interval"
                              fullWidth
                              variant="outlined"
                              defaultValue={intermediateDetails['time_interval_minute']}
                              onChange={(e) => {
                                if (e.target.value <= 0) {
                                  setIntermediateTimeInterval({ value: 0, error: "Enter valid interval" });
                                } else {
                                  setIntermediateTimeInterval({ value: e.target.value, error: "" });
                                }
                              }}
                              type="number"
                              error={intermediateTimeInterval.error != ""}
                              helperText={intermediateTimeInterval.error}
                            />
                          </Box>


                          <Box mt={2} mb={2}>
                            <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                              <InputLabel htmlFor="status">Status</InputLabel>
                              <Select
                                size="small"
                                helperText={intermediateStatus.value}
                                label="Select status"
                                inputProps={{
                                  name: 'status',
                                  id: 'status',
                                }}
                                onChange={(e) => {
                                  if (e.target.value == "") {
                                    setIntermediateStatus({ value: "", error: "Select status" });
                                  } else {
                                    setIntermediateStatus({ value: e.target.value, error: "" });
                                  }

                                }}

                                defaultValue={intermediateStatus.value}

                                error={intermediateStatus.error != ""}

                              >
                                <MenuItem value="">
                                  <em>None</em>
                                </MenuItem>
                                <MenuItem value={"INITIAL"}>INITIAL</MenuItem>
                                <MenuItem value={"PLANED"}>PLANED</MenuItem>
                                <MenuItem value={"CANCELED"}>CANCELED</MenuItem>
                              </Select>
                              <FormHelperText error={intermediateStatus.error != ""}>{intermediateStatus.error}</FormHelperText>
                            </FormControl>
                          </Box>


                          <Button
                            variant="outlined"
                            size="small"
                            color="primary"
                            className={classes.btn2}
                            onClick={handleEditClose}
                          >
                            Close
                          </Button>
                          <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            className={classes.btn}
                            disableElevation
                            onClick={() => {
                              edit_intermediate();
                            }}
                          >
                            {editIntermediateLoad ? <CircularProgress color="secondary" size={23} /> : "Save"}
                          </Button>
                        </Box>

                      </Popover>


                    </ListItemSecondaryAction>
                  </ListItem>;
                })}

              </List>

            </Box>
          </DialogContentText>

        </DialogContent>

        <DialogActions>

          <Button className={classes.btn} onClick={() => {
            setIntermediateDialog(false);
          }} color="secondary" >
            Close
          </Button>




        </DialogActions>
      </Dialog>

      {/* insert stop between stops  */}




      <Dialog
        maxWidth="sm"
        minHeight={200}
        fullWidth
        open={betweenDialog}
        aria-labelledby="add_stop_between"
        aria-describedby="add_stop_bwtween"
      >
        <DialogTitle id="stop_between">Add Stop between stops</DialogTitle>
        <DialogContent>
          <DialogContentText >
            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>

              <Autocomplete
                size="small"
                options={stops}
                getOptionLabel={(option) => option.name}
                fullWidth
                onChange={(event, newValue) => {

                  if (newValue == null) {
                    setNewStop({ value: 0, error: "Select stop" })
                  } else {
                    setNewStop({ value: newValue.id, error: "" });
                  }
                }}
                renderInput={(params) => <TextField {...params} label="Select stop" variant="outlined" />}


              />
            </Box>

            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>

              <Autocomplete
                size="small"
                options={routeStops}
                getOptionLabel={(option) => option.stop.name}
                fullWidth
                onChange={(event, newValue) => {

                  if (newValue == null) {
                    setFirstStop({ value: 0, error: "Select first stop" });
                  } else {
                    setFirstStop({ value: newValue.id, error: "" });
                  }
                }}
                renderInput={(params) => <TextField {...params} label="Select first stop" variant="outlined" />}


              />
            </Box>

            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>

              <Autocomplete
                size="small"
                options={routeStops}
                getOptionLabel={(option) => option.stop.name}
                fullWidth
                onChange={(event, newValue) => {

                  if (newValue == null) {
                    setSecondStop({ value: 0, error: "Select second stop" });
                  } else {
                    setSecondStop({ value: newValue.id, error: "" });
                  }
                }}
                renderInput={(params) => <TextField {...params} label="Select second stop" variant="outlined" />}


              />
            </Box>



          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button className={classes.btn} onClick={() => {
            setBetweendialog(false);
          }} color="secondary" >
            Close
          </Button>


          <Button className={classes.btn} onClick={() => {
            insert_stop_between();

          }} color="primary" variant="contained" disabled={betweenLoad}>

            {betweenLoad ? <CircularProgress color="secondary" size={25} /> : "Add stop"}

          </Button>



        </DialogActions>
      </Dialog>


      {/* add intermediate route */}

      <Dialog
        maxWidth="sm"
        minHeight={200}
        fullWidth
        open={addIntermediateDialog}
        aria-labelledby="add_intermediate"
        aria-describedby="add_intermediate"
      >
        <DialogTitle id="stop_between">New Intermediate route</DialogTitle>
        <DialogContent>
          <DialogContentText >
            {/* origin stop id  */}

            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>

              <FormControl fullWidth>
                <Autocomplete
                  size="small"
                  options={routeStops}
                  getOptionLabel={(option) => option.stop.name}
                  fullWidth
                  onChange={(event, newValue) => {

                    if (newValue == null) {
                      setOriginRouteStopId({ value: 0, error: "Select origin stop" });
                    } else {
                      setOriginRouteStopId({ value: newValue.id, error: "" });
                    }
                  }}
                  renderInput={(params) => <TextField {...params} label="Select origin stop" variant="outlined" />}
                />
                <FormHelperText error={originRouteStopId.error != ""}>{originRouteStopId.error}</FormHelperText>
              </FormControl>
            </Box>

            {/* detsination stop id  */}

            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
              <FormControl fullWidth>
                <Autocomplete
                  size="small"
                  options={routeStops}
                  getOptionLabel={(option) => option.stop.name}
                  fullWidth
                  onChange={(event, newValue) => {

                    if (newValue == null) {
                      setDestinationRouteStopId({ value: 0, error: "Select destination stop" });
                    } else {
                      setDestinationRouteStopId({ value: newValue.id, error: "" });
                    }
                  }}
                  renderInput={(params) => <TextField {...params} label="Select destination stop" variant="outlined" />}
                />
                <FormHelperText error={destinationRouteStopId.error != ""}>{destinationRouteStopId.error}</FormHelperText>
              </FormControl>
            </Box>



            <Box mt={1} display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
              type="number"
              onChange={(e) => {
                if (e.target.value <= 0) {
                  setIinterval({ value: 0, error: "Enter valid mins" });
                } else {
                  setIinterval({ value: e.target.value, error: "" })
                }
              }}
              error={iInterval.error != ""}
              helperText={iInterval.error}
              label={"Interval Time (mins)"} color='primary' fullWidth />
            </Box>



            <Box mt={1} display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
              type="number"
              onChange={(e) => {
                if (e.target.value <= 0) {
                  setIdistance({ value: 0, error: "Enter valid distance" });
                } else {
                  setIdistance({ value: e.target.value, error: "" });
                }

              }}
              error={iDistance.error != ""}
              helperText={iDistance.error}
              label={"Distance (Km)"} color='primary' fullWidth />
            </Box>


            <Box mt={1} display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
              type="number"
              onChange={(e) => {
                if (e.target.value <= 0) {
                  setTotalRouteCost({ value: 0, error: "Enter valid price" });
                } else {
                  setTotalRouteCost({ value: e.target.value, error: "" });
                }
              }}
              error={totalRouteCost.error != ""}
              helperText={totalRouteCost.error}
              label={"Price"} color='primary' fullWidth />
            </Box>

            <Box mt={1} display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
              type="number"
              onChange={(e) => {
                setIequivalence({ value: e.target.value, error: "" });
              }}
              label={"Equivalance (Optional)"} color='primary' fullWidth />
            </Box>




          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button className={classes.btn} onClick={() => {
            setAddIntermediateDialog(false);
          }} color="secondary" >
            Cancel
          </Button>


          <Button className={classes.btn} onClick={() => {
            add_intermediate();
          }} color="primary" variant="contained" disabled={addIntermediateLoad}>

            {addIntermediateLoad ? <CircularProgress color="secondary" size={25} /> : "Add"}

          </Button>



        </DialogActions>
      </Dialog>



      {/* end add intermediate route */}



      {/* generate intermediate routes  */}

      {/* warning message  */}

      <Dialog
        maxWidth="sm"
        minHeight={200}
        fullWidth
        open={generateDialog}

        aria-labelledby="generate_intermediate"
        aria-describedby="generate_intermediate"
      >
        <DialogTitle id="stop_between">Generate Intermediate route</DialogTitle>
        <DialogContent>
          <DialogContentText >
            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>

              <Typography >Are sure you want to generate all intermediate routes?</Typography>
            </Box>
            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
              <HelpOutline fontSize="large" /><Typography >This might take a long time than expected,be patient</Typography>

            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button className={classes.btn} onClick={() => {
            setGenerateDialog(false);
          }} color="secondary" >
            No
          </Button>


          <Button className={classes.btn} onClick={() => {
            generate_intermediate_routes();

          }} color="primary" variant="contained" disabled={generateLoad}>

            {generateLoad ? <CircularProgress color="secondary" size={25} /> : "Yes"}

          </Button>



        </DialogActions>
      </Dialog>








      {/* //// remove all intermediates routes  */}


      <Dialog
        maxWidth="sm"
        minHeight={200}
        fullWidth
        open={removeDialog}

        aria-labelledby="generate_intermediate"
        aria-describedby="generate_intermediate"
      >
        <DialogTitle id="stop_between">Remove All Intermediate route</DialogTitle>
        <DialogContent>
          <DialogContentText >
            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>

              <Typography >Are sure you want to remove all intermediate routes?</Typography>
            </Box>
            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
              <HelpOutline fontSize="large" /><Typography >You wan't be able to restore again unless you generate them again</Typography>

            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button className={classes.btn} onClick={() => {
            setRemoveDialog(false);
          }} color="secondary" >
            No
          </Button>


          <Button className={classes.btn} onClick={() => {
            remove_intermediate();

          }} color="primary" variant="contained" disabled={removeLoad}>

            {removeLoad ? <CircularProgress color="secondary" size={25} /> : "Yes"}

          </Button>



        </DialogActions>
      </Dialog>



      {/* assign user to route outlet */}


      <Dialog
        maxWidth="sm"
        minHeight={200}
        fullWidth
        open={assignDialog}

        aria-labelledby="assign_user"
        aria-describedby="assign_user"
      >
        <DialogTitle id="assign_user">Add user to route and outlet </DialogTitle>
        <DialogContent>
          <DialogContentText >

            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
              <Autocomplete
                size="small"
                options={outlets}
                getOptionLabel={(option) => option.outlet.name}
                fullWidth
                onChange={(event, newValue) => {

                  if (newValue == null) {
                    setRouteOutletId({ value: 0, error: "Select outlet" });
                  } else {
                    console.log("outlet :" + newValue.id);
                    setRouteOutletId({ value: newValue.id, error: "" });
                  }
                }}

                renderInput={(params) => <TextField {...params} label="Select outlet" variant="outlined" />}
              />
            </Box>
            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>

              <Autocomplete
                size="small"
                options={users}
                getOptionLabel={(option) => option.names}
                fullWidth
                onChange={(event, newValue) => {

                  if (newValue == null) {
                    setUserId({ value: 0, error: "Select user" });
                  } else {
                    console.log("user:" + newValue.id);
                    setUserId({ value: newValue.id, error: "" });
                  }
                }}
                renderInput={(params) => <TextField {...params} label="Select user" variant="outlined" />}
              />
            </Box>

          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button className={classes.btn} onClick={() => {

            setAssignDialog(false);
          }} color="secondary" >
            Cancel
          </Button>


          <Button className={classes.btn} onClick={() => {
            assign_user_to_routeoutlet()
          }} color="primary" variant="contained" disabled={assignLoad}>

            {assignLoad ? <CircularProgress color="secondary" size={25} /> : "Assign"}

          </Button>



        </DialogActions>
      </Dialog>



      {/* dialog create route in steps  */}



      <Dialog
        maxWidth="sm"
        minHeight={200}
        fullWidth
        open={open}

        aria-labelledby="assign_user"
        aria-describedby="assign_user"
      >
        <DialogTitle id="assign_user">Create Route </DialogTitle>
        <DialogContent>
          <DialogContentText >



            <Stepper activeStep={activeStep} alternativeLabel>


              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}


            </Stepper>
            <Box>
              {activeStep === steps.length ? (
                <Box>
                  <Typography >All steps completed</Typography>
                  <Button onClick={handleReset}>Reset</Button>
                </Box>
              ) : (
                <Box>
                  <Typography >


                    {/* {getStepContent(activeStep)} */}
                    {
                      activeStep == 0 &&



                      <Box>

                        {/* <Box display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
          onChange={(e)=>{
            if(e.target.value===""){
              setName({value:"",error:"Enter route name"});
            }else{
              setName({value:e.target.value,error:""});
            }
          }}
          value={name.value}
          error={name.error!=""}
          helperText={name.error}
           label={<Translate id="operator_route.from_new_route.name" />}  color='primary'  fullWidth/></Box> */}



                        <Box mt={1} display='flex' alignItems='center' justifyContent='center'>

                          <Autocomplete
                            size="small"
                            options={stops}
                            getOptionLabel={(option) => option.name}
                            fullWidth
                            onChange={(event, newValue) => {

                              if (newValue == null) {
                                setOrigin({ value: 0, error: "Select origin" });
                              } else {
                                setName({ value: newValue.name, error: "" });
                                setOrigin({ value: newValue.id, error: "" });
                              }
                            }}
                            renderInput={(params) => <TextField {...params} label="Select origin" variant="outlined" />}


                          />




                        </Box>

                        <Box mt={1} display='flex' alignItems='center' justifyContent='center'>

                          <Autocomplete
                            size="small"
                            options={stops}
                            getOptionLabel={(option) => option.name}
                            fullWidth
                            onChange={(event, newValue) => {

                              if (newValue == null) {
                                setDestination({ value: 0, error: "" });
                              } else {
                                var n_name = name.value + "-" + newValue.name;
                                setName({ value: n_name, error: "" });
                                setDestination({ value: newValue.id, error: "" });
                              }
                            }}
                            renderInput={(params) => <TextField {...params} label="Select destination" variant="outlined" />}

                          />

                        </Box>





                        <Box display='flex' mt={1} alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
                          type="number"
                          onChange={(e) => {
                            if (e.target.value === "") {
                              setCost({ value: "", error: "Enter route cost" });
                            } else {
                              setCost({ value: e.target.value, error: "" });
                            }
                          }}
                          error={cost.error != ""}
                          helperText={cost.error}
                          label={<Translate id="operator_route.from_new_route.cost" />} color='primary' fullWidth /></Box>

                        <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                          <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                            <InputLabel htmlFor="currency"><Translate id="operator_route.from_new_route.choose_currency" /></InputLabel>
                            <Select
                              size="small"
                              helperText={"error"}
                              label="Select currency"
                              inputProps={{
                                name: 'currency',
                                id: 'currency',
                              }}
                              onChange={(e) => {
                                if (e.target.value === "") {
                                  setCostcurrency({ value: "", error: "Select currency" });
                                } else {
                                  setCostcurrency({ value: e.target.value, error: "" });
                                }
                              }}
                              error={costCurrency.error != ""}

                            >
                              <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {/* {currencies.map((c)=>{
            return <MenuItem value={c['id']}>{c['code']}</MenuItem>;
          })} */}
                              <MenuItem value={"RWF"}>RWF</MenuItem>
                              <MenuItem value={"USD"}>USD</MenuItem>
                            </Select>
                            <FormHelperText error={costCurrency.error != ""}>{costCurrency.error}</FormHelperText>
                          </FormControl>
                        </Box>




                        <Box mt={1}>
                          <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>

                            <TextField size="small" rowsMax={5} rows={10} variant='outlined' label={<Translate id="operator_route.from_new_route.description" />}
                              onChange={(e) => {
                                if (e.target.value == "") {
                                  setDescription({ value: "", error: "Enter description" });
                                } else {
                                  setDescription({ value: e.target.value, error: "" });
                                }
                              }}
                              error={description.error !== ""}
                              helperText={description.error}
                              color='primary' fullWidth multiline />
                          </FormControl>
                        </Box>
                      </Box>

                    }
                    {
                      activeStep == 1 &&

                      <Box>

                        <Box display='flex' mt={1} alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
                          onChange={(e) => {
                            if (e.target.value === "") {
                              setPhone({ value: "", error: "Enter phone number" });
                            } else {
                              setPhone({ value: e.target.value, error: "" });
                            }
                          }}
                          // value={phone.value}
                          error={phone.error != ""}
                          helperText={phone.error}
                          label={<Translate id="operator_route.form_modify_route.phone" />} color='primary' fullWidth /></Box>





                        <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                          <TextField size='small' variant='outlined' type="number" label={<Translate id="operator_route.form_modify_route.interval_minute" />}
                            // value={intervalTime.value}
                            error={intervalTime.error !== ""}
                            helperText={intervalTime.error}
                            onChange={(e) => {
                              if (e.target.value === 0) {
                                console.log(e.target.value);
                                setIntervalTime({ value: 0, error: "Enter interval time" });
                              } else {
                                setIntervalTime({ value: e.target.value, error: "" })
                              }
                            }}
                            color='primary' fullWidth />
                        </Box>
                        <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                          <TextField size='small' variant='outlined' type="number" label={<Translate id="operator_route.form_modify_route.distance" />}
                            // value={distance.value}
                            onChange={(e) => {
                              if (e.target.value === 0) {
                                setDistance({ value: 0, error: "Enter distance" });
                              } else {
                                setDistance({ value: e.target.value, error: "" });
                              }
                            }}
                            color='primary' fullWidth />
                        </Box>

                        {/* <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
          
          <Autocomplete
          size="small"
      options={stops}
      getOptionLabel={(option) => option.name}
      fullWidth
      onChange={(event, newValue) => {
       
        if(newValue==null){
          setOrigin({value:0,error:"Select origin"});
        }else{
          setOrigin({value:newValue.id,error:""});
        }
      }}
      renderInput={(params) => <TextField {...params} label="Select origin" variant="outlined" />}

    
    />



        
</Box>

<Box mt={1} display='flex' alignItems='center' justifyContent='center'>

<Autocomplete
size="small"
      options={stops}
      getOptionLabel={(option) => option.name}
      fullWidth
      onChange={(event, newValue) => {
       
        if(newValue==null){
          setDestination({value:0,error:""});
        }else{
          setDestination({value:newValue.id,error:""});
        }
      }}
      renderInput={(params) => <TextField {...params} label="Select destination" variant="outlined" />}

    />

</Box> */}


                        <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                          <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                            <InputLabel htmlFor="currency"><Translate id="operator_route.form_modify_route.choose_currency" /></InputLabel>
                            <Select
                              size="small"
                              helperText={"error"}
                              label="Select currency"
                              inputProps={{
                                name: 'currency',
                                id: 'currency',
                              }}
                              onChange={(e) => {
                                if (e.target.value === 0) {
                                  setCurrencyid({ value: 0, error: "Select currency" });
                                } else {
                                  if (e.target.value === 1) {
                                    setIsrwandan(true);
                                  } else {
                                    setIsrwandan(false);
                                  }
                                  setCurrencyid({ value: e.target.value, error: "" });
                                }
                              }}
                              error={costCurrency.error != ""}
                            >
                              <MenuItem value={0}>
                                <em>None</em>
                              </MenuItem>
                              {currencies.map((c) => {
                                return <MenuItem value={c['id']}>{c['code']}</MenuItem>;
                              })}
                            </Select>
                            <FormHelperText error={costCurrency.error != ""}>{costCurrency.error}</FormHelperText>
                          </FormControl>
                        </Box>
                        {isRwandan == false && <Box display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'
                          onChange={(e) => {
                            if (e.target.value === "") {
                              setRwequivalence({ value: "", error: "Enter equivalent" });
                            } else {
                              setRwequivalence({ value: e.target.value, error: "" });
                            }
                          }}
                          error={rwEquivalence.error != ""}
                          helperText={rwEquivalence.error}
                          label={<Translate id="operator_route.form_modify_route.equivalence" />} color='primary' fullWidth />
                        </Box>}


                      </Box>

                    }

                    {activeStep == 2 &&
                      <Box>

                        {/* <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
      
      <Autocomplete
      size="small"
  options={branches}
  getOptionLabel={(option) => option.name}
  fullWidth
  onChange={(event, newValue) => {

  
    if(newValue==null){
    setOutletFilter([]);
    }else{
     setOutletFilter(outletsAssign.filter((o)=>o.branch.id==newValue.id));
   
    }
  }}
  renderInput={(params) => <TextField {...params} label="Select Branch" variant="outlined" />}
/>

    
</Box> */}


                        <Box mt={1} display='flex' alignItems='center' justifyContent='center'>

                          <Autocomplete
                            multiple
                            size="small"
                            disableCloseOnSelect
                            options={outletsAssign}
                            getOptionLabel={(option) => option.name}
                            renderOption={(option, { selected }) => (
                              <React.Fragment>
                                <Checkbox
                                  icon={<CheckBoxOutlineBlank fontSize="small" />}
                                  checkedIcon={<CheckBox fontSize="small" />}
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                {option.name}
                              </React.Fragment>
                            )}
                            fullWidth
                            // onChange={(event, newValue) => {

                            //   if(newValue==null){
                            //     setOUtletId({value:0,error:"Choose outlet"});
                            //   }else{
                            //     setOUtletId({value:newValue.id,error:""});
                            //   }
                            // }}

                            onChange={(event, newValue) => {
                              console.log("new value", newValue);
                              var ids = [];
                              newValue.map((n) => {
                                ids.push(n['id']);
                              });
                              console.log("=== putlet ids ======", ids);
                              setOUtletId({ value: ids, error: "" });
                            }}


                            renderInput={(params) => <TextField {...params} label="Select outlets" variant="outlined" />}
                          />

                          {/* <Autocomplete
        multiple
        id="routes"
        options={routes}
        getOptionLabel={(option) => option.name}
        // defaultValue={[top100Films[13]]}
       

        // value={value}
        onChange={(event, newValue) => {
          console.log("new value",newValue);
          var ids=[];
          newValue.map((n)=>{
            ids.push(n['id']);
          });
          console.log(ids);
          setRoutesOutlet(ids);
        }}

       
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Select routes"
            placeholder="Routes"
          />
        )}
      /> */}

                        </Box>

                      </Box>
                    }

                  </Typography>

                  <Box mt={2}>

                    {/* <Button
                disabled={activeStep === 0}
                onClick={handleBack}
              >
                Back
              </Button> */}

                    <Button variant="contained" color="primary"
                      disabled={modifyStatus.load}
                      onClick={() => {
                        console.log("step", activeStep);
                        if (activeStep === 1) {
                          console.log("modifying route", activeStep);
                          modify_route();
                        } else if (activeStep === 0) {
                          addRoute();
                        } else if (activeStep === 2) {
                          assign_route_outlet();
                        }
                      }
                      }>
                      {activeStep === steps.length - 1 ? modifyStatus.load ? <CircularProgress size={25} color="secondary" /> : 'Save' : addStatus.load ? <CircularProgress size={25} color="secondary" /> : 'Next'}
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>

          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button className={classes.btn} onClick={() => {
            setOpen(false);
            setActiveStep(0);
          }} color="secondary" >
            Cancel
          </Button>

        </DialogActions>
      </Dialog>





      {/* upload prices  */}



      <Dialog
        open={uploadDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"

        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">

          <Box display="flex" alignItems="center">
            <Box flexGrow={1}>Upload Prices</Box>


            <Button color="primary" startIcon={<GetApp />} onClick={downloadRouteTemplate}>
              Download template
            </Button>

          </Box>

        </DialogTitle>
        <DialogContent>

          <Box mb={2} mr={2} display="flex" justifyContent="center">
            <Dropzone
              onDrop={(acceptedFiles) => {
                console.log(JSON.stringify(acceptedFiles));
                setChoosenFile(
                  acceptedFiles.map((file) =>
                    Object.assign(file, {
                      preview: URL.createObjectURL(file),
                    })
                  )
                );

                setPriceFile(acceptedFiles);

              }}
              accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              multiple={false}
              noClick={choosenFile.length != 0}
            >
              {({
                getRootProps,
                getInputProps,
                isDragActive,
                isDragReject,
              }) => (
                <CardActionArea disableRipple={choosenFile.length != 0}>
                  {" "}
                  <Box
                    borderRadius="borderRadius"
                    p={2}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    style={{ border: "dashed 1px grey" }}
                    {...getRootProps()}
                  >
                    {
                      <Box mr={2}>
                        {choosenFile.length != 0 ? (
                          <Description fontSize="large" color="primary" />
                        ) : (
                          <Attachment fontSize="large" color="action" />
                        )}
                      </Box>
                    }
                    <input {...getInputProps()} />

                    {choosenFile.length != 0 ? (
                      <Box display="flex" alignItems="center">
                        <Typography color="primary">
                          {choosenFile[0].name}
                        </Typography>
                        <IconButton onClick={() => setChoosenFile([])}>
                          <Close />
                        </IconButton>
                      </Box>
                    ) : (
                      !isDragActive && (
                        <Typography color="textPrimary">
                          Drop the file here or click to upload...
                        </Typography>
                      )
                    )}

                    {isDragActive && !isDragReject && (
                      <Typography color="primary">Drop it here!</Typography>
                    )}
                    {isDragReject && (
                      <Typography color="error">
                        File type not accepted, sorry!
                      </Typography>
                    )}
                  </Box>
                </CardActionArea>
              )}
            </Dropzone>

          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              setUploadDialog(false);
            }}
          >
            Cancel
          </Button>
          <Button
            className={classes.btn}
            variant="contained"
            color="primary"
            disableElevation
            autoFocus
            disabled={uploadPriceLoad}
            onClick={() => {
              uploadPrice();
            }}
          >
            {uploadPriceLoad ? <CircularProgress size={25} color="primary" /> : "Upload"}

          </Button>
        </DialogActions>
      </Dialog>




    </Box>
  );
}


export default withLocalize(Route)